function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "32.54 21.46 697.87 451.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.18,112.49c97.48-48,197.73-110.75,311-85.07,35.11,8,67.06,27.87,88.66,56.81,57.75,77.39,53.06,195.92,21.68,283a158.37,158.37,0,0,1-15.79,32.55c-31.85,49.15-85.51,51.47-137.28,37.26-43.8-12-82.61-24.4-127.86-12.17-25.06,6.77-49.35,16.08-74.32,23.17-34,9.64-69.05,16.19-104.45,16.86-93.67,1.75-200.67-46-209-150.63a167.16,167.16,0,0,1-.33-20.39c1.88-41.76,15.68-83.58,53.93-105.26,38.46-21.8,84.09-30.41,125.23-45.87C241,134,263.74,123.54,286.18,112.49Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.18,112.49c97.48-48,197.73-110.75,311-85.07,35.11,8,67.06,27.87,88.66,56.81,57.75,77.39,53.06,195.92,21.68,283a158.37,158.37,0,0,1-15.79,32.55c-31.85,49.15-85.51,51.47-137.28,37.26-43.8-12-82.61-24.4-127.86-12.17-25.06,6.77-49.35,16.08-74.32,23.17-34,9.64-69.05,16.19-104.45,16.86-93.67,1.75-200.67-46-209-150.63a167.16,167.16,0,0,1-.33-20.39c1.88-41.76,15.68-83.58,53.93-105.26,38.46-21.8,84.09-30.41,125.23-45.87C241,134,263.74,123.54,286.18,112.49Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.84,327.93s-2.33,6.43-7.3,7.3-13.73-8.76-8.18-13.73S645.51,324.42,647.84,327.93Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.88,335.79c-3.25,0-7.25-3.39-8.89-6.78-1.5-3.08-1.12-5.95,1-7.88a6.4,6.4,0,0,1,5.27-1.67c4.42.56,9,5.21,11,8.19a.48.48,0,0,1,0,.45c-.1.27-2.49,6.71-7.68,7.62A3.81,3.81,0,0,1,639.88,335.79ZM636.4,320.4a5.47,5.47,0,0,0-3.71,1.47c-2.46,2.21-1.56,5.14-.81,6.7,1.77,3.64,5.93,6.64,8.57,6.17,4.1-.72,6.36-5.62,6.83-6.75-1.9-2.74-6.17-7-10.12-7.54A6.61,6.61,0,0,0,636.4,320.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.44,296.37s-7.3,17.83-4.38,26.59,21,15.19,26.29,3.8-6.42-27.47-10.81-31S656.9,293.45,655.44,296.37Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.24,333.38l-.93,0c-6.92-.38-14-5-15.73-10.23-2.94-8.84,4.1-26.2,4.4-26.94,0,0,0,0,0,0a5.7,5.7,0,0,1,4-2.84,9.42,9.42,0,0,1,7.86,2.09c4.49,3.59,16.32,19.92,10.95,31.57C675.89,331.13,672.16,333.38,667.24,333.38Zm-11.34-36.8c-.26.64-7.16,17.85-4.37,26.22,1.61,4.82,8.4,9.2,14.84,9.56,2.85.14,8-.39,10.53-5.81,5.15-11.15-6.32-26.89-10.67-30.37a8.41,8.41,0,0,0-7-1.89A4.68,4.68,0,0,0,655.9,296.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.1,304s-12.57,11.39-14,22.79,7,15.48,15.78,14,13.15-23.66,10.52-33.89S698.1,304,698.1,304Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.47,341.57a13.71,13.71,0,0,1-9.66-3.44c-2.74-2.64-3.85-6.59-3.23-11.43,1.47-11.45,13.66-22.63,14.18-23.1l0,0c.2-.15,4.93-3.69,8.86-2.31,2,.7,3.44,2.55,4.19,5.51,1.91,7.4.21,22-4.84,29.77-1.8,2.77-3.85,4.37-6.08,4.74A21.83,21.83,0,0,1,696.47,341.57Zm1.95-37.22c-.53.49-12.45,11.59-13.85,22.47-.58,4.52.44,8.18,2.93,10.59,2.78,2.67,7.25,3.72,12.27,2.88,1.94-.32,3.76-1.77,5.4-4.3,4.91-7.54,6.57-21.77,4.72-29-.67-2.61-1.87-4.23-3.55-4.82C703,301,698.72,304.13,698.42,304.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.44,367.08s-14,.59-14.61,7.31,6.13,8.18,12.85,2.33S706.28,367.37,700.44,367.08Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.69,380.88a5.8,5.8,0,0,1-2.68-.6c-2-1-2.93-3.12-2.68-5.94.61-7.07,14.5-7.73,15.09-7.76h0c2.4.12,3.83.79,4.24,2,.64,1.86-1.22,4.64-5.69,8.53C696.18,379.56,693.2,380.88,690.69,380.88Zm9.75-13.3c-.62,0-13.59.76-14.11,6.85-.21,2.39.55,4.15,2.14,5,2.45,1.24,6.33.05,9.89-3,5.33-4.64,5.67-6.66,5.4-7.45C703.42,367.94,701.77,367.65,700.44,367.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.27,376.44l-.42-.91c.46-.21,11.17-5.09,16.15-6l.18,1C697.32,371.4,686.38,376.39,686.27,376.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.56,411.05s-10.3-9.53-15.48-5.21-1.47,10.12,7.41,10.77S707.48,415.4,703.56,411.05Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.67,417.23c-1,0-2,0-3.22-.12-5.19-.38-9-2.51-10-5.56-.68-2.11.15-4.28,2.32-6.09,5.46-4.56,15.71,4.83,16.14,5.23l0,0c1.61,1.78,2.14,3.27,1.58,4.41C704.82,416.54,702.57,417.23,698.67,417.23Zm-7.27-12a4.53,4.53,0,0,0-3,1c-1.84,1.53-2.55,3.31-2,5,.84,2.62,4.42,4.53,9.12,4.87,7.06.51,8.73-.67,9.09-1.42.45-.92-.51-2.29-1.4-3.28C702.83,411.06,696.32,405.21,691.4,405.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.33,414.73c-4-2.84-15.28-7.08-15.4-7.13l.36-.93c.46.17,11.48,4.33,15.62,7.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.22,408.25s14.2-13.15,21.34-7.19,2,13.95-10.21,14.84S643.83,414.24,649.22,408.25Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.93,416.58c-5.27,0-8.3-.93-9.22-2.8-.74-1.5,0-3.47,2.14-5.87l0,0c.59-.55,14.61-13.37,22-7.2,2.94,2.45,4,5.36,3.14,8.19-1.33,4.13-6.56,7-13.63,7.53C658.76,416.52,657.27,416.58,655.93,416.58Zm-6.35-8c-1.27,1.41-2.64,3.38-2,4.74.52,1.08,2.88,2.78,12.71,2.06,6.56-.47,11.56-3.16,12.75-6.84.77-2.41-.23-4.94-2.83-7.11C663.62,395.92,650.13,408.1,649.58,408.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.81,413.16l-.58-.82c5.68-4,20.85-9.72,21.49-10l.36.93C671.92,403.37,656.39,409.23,650.81,413.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.67,381.11s-1.46,7-6.72,9.64-14.61-2.92-9.65-11.4S663,377.6,665.67,381.11Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656,391.9a9.23,9.23,0,0,1-6.59-2.84c-2.5-2.67-2.7-6.3-.55-10,1.6-2.73,3.72-4.19,6.3-4.34,4.42-.25,9,3.57,10.9,6.05a.56.56,0,0,1,.09.4c-.07.29-1.58,7.28-7,10A7,7,0,0,1,656,391.9Zm-.43-16.15h-.35c-2.22.12-4.07,1.42-5.49,3.85-1.91,3.25-1.76,6.45.41,8.77s6,3.21,8.57,1.92c4.47-2.23,6.11-7.9,6.41-9.08C663.26,378.84,659.24,375.75,655.58,375.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.39,359.19s-2.62-5.84-12.85-2-14.32,9.64-7.89,11.68S653.39,359.19,653.39,359.19Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.32,369.57a5.93,5.93,0,0,1-1.82-.26c-2.79-.89-3.41-2.36-3.43-3.44-.08-3,4.36-6.62,11.3-9.19,10.54-3.92,13.45,2.24,13.48,2.31a.5.5,0,0,1-.14.59C653.17,360,641.38,369.57,634.32,369.57Zm12.48-13.22a17.61,17.61,0,0,0-6.09,1.27c-7.38,2.74-10.69,6.19-10.64,8.23,0,1.36,1.5,2.12,2.73,2.51,5.57,1.77,17.79-7.59,20-9.29C652.24,358.27,650.6,356.35,646.8,356.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.07,365.46l-.65-.77c5.91-5,16.51-6.21,17-6.26l.11,1C651.38,359.43,640.74,360.64,635.07,365.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.61,289.07s1.76,4.09,5.26,3.21,4.39-6.13,9.94-4.67,10.22,7.89,10.22,5-7-10.51-14.9-10.51S682.91,285.27,682.61,289.07Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.59,293.83c-.67,0-1.55-.68-3-1.75-1.82-1.39-4.3-3.29-7-4-3.16-.83-4.63.66-6.19,2.25a7.67,7.67,0,0,1-3.5,2.43c-3.09.77-5.17-2-5.84-3.51a.45.45,0,0,1,0-.23c.38-5,4.08-7.48,11-7.48,8,0,15.4,7.58,15.4,11a1.25,1.25,0,0,1-.53,1.17A1,1,0,0,1,707.59,293.83Zm-11.61-7a7.53,7.53,0,0,1,1.95.27c2.84.75,5.42,2.72,7.31,4.17a12,12,0,0,0,2.27,1.53,1.29,1.29,0,0,0,0-.25c0-2.45-6.48-10-14.4-10-6.34,0-9.62,2.11-10,6.43.3.62,1.84,3.51,4.63,2.82a6.91,6.91,0,0,0,3-2.16C692.08,288.31,693.52,286.85,696,286.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672,375.14a39.66,39.66,0,0,0-1.29-4.22c-5-13.39-16.76-11.33-17.26-11.24l-.19-1c.13,0,13.06-2.33,18.38,11.87A39.44,39.44,0,0,1,673,374.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.9,345.66s2.63-5.85,12.86-2.05,14.31,9.64,7.89,11.69S705.9,345.66,705.9,345.66Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725,356c-7.06,0-18.84-9.55-19.38-10a.48.48,0,0,1-.14-.59c0-.06,2.94-6.22,13.48-2.31,6.94,2.58,11.37,6.19,11.3,9.2,0,1.08-.64,2.55-3.43,3.44A6.27,6.27,0,0,1,725,356Zm-18.42-10.5c2.17,1.71,14.37,11,20,9.28,1.23-.39,2.7-1.14,2.73-2.51,0-2-3.26-5.49-10.65-8.23C710.35,341,707.29,344.42,706.55,345.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.37,351.92c-4.76-5.88-15-5.38-15.1-5.38l-.06-1c.44,0,10.85-.52,15.94,5.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.39,347.3l-.4-.91a16.48,16.48,0,0,1,9-1.22l-.19,1A15.78,15.78,0,0,0,697.39,347.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.74,335.53c-6-6.09-11.91-7.1-12-7.11s-8.83-2.28-12.1.72l-.67-.74c3.67-3.37,12.59-1.06,13-1,.21,0,6.28,1,12.49,7.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.58,
    y: 300.34,
    width: 1,
    height: 2.5,
    transform: "translate(-49.98 152) rotate(-12.64)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.08,432l-1,0c0-.51,1.3-50.47,0-65.55s-7.33-32.88-7.39-33.06l-6.25-27.85,1-.22,6.23,27.8c0,.13,6.13,18.08,7.43,33.25S676.09,431.49,676.08,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700.78,
    y: 311.91,
    width: 2.66,
    height: 1,
    transform: "translate(121.69 816.06) rotate(-64.94)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.14,431.93h-1c0-.46.45-46.08,2.19-59.06s8.68-33.5,8.75-33.71l10.74-23,.91.42-10.72,23c0,.16-7,20.58-8.69,33.48S679.14,431.47,679.14,431.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.76,432l-1-.06c1.72-29.37,4.77-55.77,4.8-56l1,.11C686.53,376.31,683.48,402.68,681.76,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.71,431.94l-1,0c0-.41.86-42-.85-47.48-.58-1.9-1.37-3.05-2.27-3.31a1.89,1.89,0,0,0-1.6.37l-.11.09-.16,0c-.07,0-7.87,1-10.64,5.4l-.85-.52c2.85-4.55,10.11-5.7,11.24-5.85a2.84,2.84,0,0,1,2.4-.47c1.26.36,2.25,1.7,3,4C672.57,389.82,671.75,430.22,671.71,431.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.9,432l-1-.05c0-.41,2.08-41-.17-53.56l1-.18C676,390.91,673.92,431.58,673.9,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.94,432c0-2.48-.54-61.05,4.67-74.95a18.83,18.83,0,0,1,6.83-9.24l.56.83a17.84,17.84,0,0,0-6.45,8.76c-5.15,13.72-4.62,74-4.61,74.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.82,432l-1-.13c1.23-9-1.26-61.31-8.27-81.47a41.11,41.11,0,0,0-7.32-13.22l.76-.65a42,42,0,0,1,7.51,13.54C676.56,370.34,679.06,422.93,677.82,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.14,431.93h-1c0-.51.3-51.23.72-76.29h1C679.44,380.7,679.14,431.42,679.14,431.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.92,352.49l-1,0c.34-20.23.67-34.36,1-42,.76-19.68,1.85-21.52,2.36-21.83.48-1.1,2.83-5.13,11.1-4.59l-.07,1c-8.54-.54-10.12,4-10.18,4.17l-.25.75-.17-.17c-.37,1.08-1.19,5.17-1.79,20.72C680.59,318.14,680.26,332.26,679.92,352.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.24,371.62s-7.31-6.51-4.39-9.72,21-5.55,26.3-1.38-6.43,10-10.81,11.32S669.7,372.69,668.24,371.62Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.51,373.13c-2.5,0-4.63-.42-5.57-1.1l0,0c-.2-.19-5-4.55-5.23-8.06a3.16,3.16,0,0,1,.81-2.37c3.17-3.48,21.49-5.8,27-1.45a3.31,3.31,0,0,1,1.46,3.35c-.76,3.93-9.1,7.87-12.44,8.85A22.12,22.12,0,0,1,673.51,373.13Zm-5-1.9c1.31.93,6.33,1.39,10.65.13,3.66-1.07,11.12-4.9,11.74-8.08a2.36,2.36,0,0,0-1.1-2.37c-5-3.93-22.84-1.72-25.62,1.33a2.17,2.17,0,0,0-.55,1.65C663.82,366.89,668.23,370.94,668.55,371.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.32,368.23h-1a13.75,13.75,0,0,1,.17-2l1,.15A11.8,11.8,0,0,0,675.32,368.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.1,363.66l-1-.28a32.13,32.13,0,0,1,1.91-4.92l.89.45A32.56,32.56,0,0,0,676.1,363.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.24,414.21s-7.31-6.51-4.39-9.72,21-5.55,26.3-1.38-6.43,10-10.81,11.32S669.7,415.28,668.24,414.21Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.51,415.72c-2.5,0-4.63-.42-5.57-1.1l0,0c-.2-.18-5-4.54-5.23-8.05a3.16,3.16,0,0,1,.81-2.37c3.17-3.48,21.48-5.8,27-1.45a3.31,3.31,0,0,1,1.46,3.35c-.76,3.93-9.1,7.87-12.44,8.85A22.12,22.12,0,0,1,673.51,415.72Zm-5-1.9c1.31.93,6.33,1.39,10.65.13,3.66-1.07,11.12-4.9,11.74-8.08a2.36,2.36,0,0,0-1.1-2.37c-5-3.93-22.84-1.72-25.62,1.33a2.17,2.17,0,0,0-.55,1.65C663.82,409.47,668.23,413.53,668.55,413.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.32,410.82h-1c0-4.27,2.61-9.55,2.73-9.77l.89.45C677.91,401.55,675.32,406.79,675.32,410.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.67,396.2s-5-4.42-3-6.6,14.28-3.77,17.85-.94-4.36,6.81-7.34,7.68S674.67,396.92,673.67,396.2Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.27,397.38a7.56,7.56,0,0,1-3.89-.78l0,0c-.14-.12-3.48-3.13-3.61-5.58a2.3,2.3,0,0,1,.6-1.72c2.18-2.39,14.76-4,18.53-1a2.39,2.39,0,0,1,1.06,2.42c-.57,2.9-6.57,5.55-8.57,6.13A14.75,14.75,0,0,1,677.27,397.38ZM674,395.81c.85.59,4.25.88,7.08.06,2.45-.72,7.45-3.26,7.86-5.37a1.44,1.44,0,0,0-.69-1.45c-3.33-2.64-15.31-1.15-17.17.89a1.31,1.31,0,0,0-.34,1C670.82,392.62,673.09,395,674,395.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.64,393.9h-1a18.35,18.35,0,0,1,1.87-6.71l.9.45A17.43,17.43,0,0,0,678.64,393.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.81,
    y: 424.68,
    width: 19.77,
    height: 43.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.59,469H666.81a.51.51,0,0,1-.5-.5V424.68a.5.5,0,0,1,.5-.5h19.78a.5.5,0,0,1,.5.5v43.85A.51.51,0,0,1,686.59,469Zm-19.28-1h18.78V425.18H667.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.32,327.93s-2.34,6.43-7.3,7.3-13.74-8.76-8.19-13.73S49,324.42,51.32,327.93Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.36,335.79c-3.26,0-7.25-3.39-8.9-6.78-1.49-3.08-1.11-5.95,1-7.88a6.4,6.4,0,0,1,5.27-1.67c4.41.56,9,5.21,11,8.19a.54.54,0,0,1,0,.45c-.1.27-2.5,6.71-7.69,7.62A3.64,3.64,0,0,1,43.36,335.79ZM39.88,320.4a5.45,5.45,0,0,0-3.71,1.47c-2.46,2.21-1.56,5.14-.81,6.7,1.77,3.64,5.94,6.63,8.57,6.17,4.1-.72,6.36-5.62,6.83-6.75-1.9-2.74-6.17-7-10.12-7.54A6.61,6.61,0,0,0,39.88,320.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.92,296.37S51.61,314.2,54.53,323s21,15.19,26.3,3.8-6.43-27.47-10.81-31S60.38,293.45,58.92,296.37Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.71,333.38l-.92,0c-6.92-.38-14-5-15.73-10.23-3-8.84,4.09-26.2,4.39-26.94l0,0a5.7,5.7,0,0,1,4-2.84,9.38,9.38,0,0,1,7.86,2.09c4.5,3.59,16.33,19.92,11,31.57C79.37,331.13,75.63,333.38,70.71,333.38Zm-11.34-36.8c-.26.64-7.15,17.85-4.36,26.22,1.61,4.82,8.4,9.2,14.83,9.56,2.87.15,8-.39,10.54-5.81,5.14-11.15-6.33-26.89-10.67-30.37a8.44,8.44,0,0,0-7-1.89A4.72,4.72,0,0,0,59.37,296.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.58,304s-12.57,11.39-14,22.79,7,15.48,15.78,14,13.15-23.66,10.52-33.89S101.58,304,101.58,304Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,341.57a13.69,13.69,0,0,1-9.66-3.44c-2.74-2.64-3.86-6.59-3.23-11.43,1.46-11.45,13.66-22.63,14.18-23.1l0,0c.2-.15,4.94-3.69,8.87-2.31,2,.7,3.43,2.55,4.19,5.51,1.91,7.4.2,22-4.84,29.77-1.81,2.77-3.85,4.37-6.08,4.74A21.83,21.83,0,0,1,100,341.57Zm2-37.22c-.53.49-12.46,11.59-13.85,22.47-.58,4.52.43,8.18,2.93,10.59,2.77,2.67,7.24,3.72,12.27,2.88,1.94-.32,3.75-1.77,5.4-4.3,4.91-7.54,6.57-21.77,4.71-29-.67-2.61-1.86-4.23-3.55-4.82C106.49,301.05,102.2,304.13,101.9,304.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91,367.08s-14,.59-14.61,7.31,6.14,8.18,12.86,2.33S109.76,367.37,103.91,367.08Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.16,380.88a5.79,5.79,0,0,1-2.67-.6c-2-1-2.93-3.12-2.68-5.94.61-7.07,14.49-7.73,15.08-7.76h0c2.4.12,3.82.79,4.24,2,.64,1.86-1.22,4.64-5.69,8.53C99.66,379.56,96.68,380.88,94.16,380.88Zm9.75-13.3c-.62,0-13.58.76-14.11,6.85-.21,2.39.56,4.15,2.15,5,2.44,1.24,6.32.05,9.88-3,5.34-4.64,5.68-6.66,5.4-7.45C106.9,367.94,105.25,367.65,103.91,367.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.74,376.44l-.41-.91c.45-.21,11.17-5.09,16.15-6l.17,1C100.8,371.4,89.85,376.39,89.74,376.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,411.05s-10.3-9.53-15.48-5.21S90.08,416,99,416.61,111,415.4,107,411.05Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.15,417.23c-1,0-2.05,0-3.22-.12-5.19-.38-9-2.51-10-5.56-.68-2.11.15-4.28,2.32-6.09,5.45-4.56,15.71,4.82,16.14,5.23l0,0c1.61,1.78,2.14,3.27,1.58,4.41C108.3,416.54,106.05,417.23,102.15,417.23Zm-7.28-12a4.53,4.53,0,0,0-3,1c-1.84,1.53-2.55,3.31-2,5,.84,2.62,4.43,4.53,9.13,4.87,7,.51,8.72-.67,9.09-1.42.45-.92-.51-2.29-1.41-3.28C106.31,411.06,99.8,405.21,94.87,405.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81,414.73c-4-2.84-15.28-7.08-15.4-7.13l.35-.93c.47.17,11.49,4.33,15.63,7.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7,408.25S66.9,395.1,74,401.06s2,13.95-10.21,14.84S47.31,414.24,52.7,408.25Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.41,416.58c-5.28,0-8.31-.93-9.23-2.8-.73-1.5,0-3.47,2.15-5.87l0,0c.59-.55,14.61-13.37,22-7.2,2.93,2.45,4,5.36,3.13,8.19-1.32,4.13-6.55,7-13.62,7.53C62.23,416.52,60.75,416.58,59.41,416.58Zm-6.36-8c-1.27,1.41-2.63,3.38-2,4.74.53,1.08,2.88,2.78,12.71,2.06,6.56-.47,11.57-3.16,12.75-6.84.78-2.41-.22-4.94-2.82-7.11C67.1,395.92,53.6,408.1,53.05,408.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.28,413.16l-.57-.82c5.68-4,20.85-9.72,21.49-10l.35.93C75.4,403.37,59.86,409.23,54.28,413.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.14,381.11s-1.46,7-6.72,9.64-14.61-2.92-9.64-11.4S66.51,377.6,69.14,381.11Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.49,391.9a9.23,9.23,0,0,1-6.59-2.84c-2.5-2.67-2.7-6.3-.55-10,1.6-2.73,3.72-4.19,6.3-4.34,4.45-.26,9,3.57,10.89,6.05a.48.48,0,0,1,.09.4c-.06.29-1.57,7.28-7,10A7,7,0,0,1,59.49,391.9Zm-.43-16.15H58.7c-2.22.12-4.07,1.42-5.49,3.85-1.91,3.25-1.75,6.45.42,8.77s6,3.22,8.57,1.92c4.47-2.23,6.1-7.9,6.4-9.08C66.73,378.84,62.72,375.75,59.06,375.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.87,359.19s-2.63-5.84-12.85-2-14.32,9.64-7.89,11.68S56.87,359.19,56.87,359.19Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8,369.57a5.93,5.93,0,0,1-1.82-.26c-2.8-.89-3.41-2.36-3.44-3.44-.07-3,4.37-6.62,11.3-9.19,10.55-3.92,13.46,2.24,13.49,2.31a.51.51,0,0,1-.14.59C56.65,360,44.86,369.57,37.8,369.57Zm12.47-13.22a17.61,17.61,0,0,0-6.08,1.27c-7.38,2.74-10.7,6.19-10.65,8.23,0,1.36,1.51,2.12,2.74,2.51,5.58,1.77,17.79-7.59,19.95-9.29C55.71,358.27,54.08,356.35,50.27,356.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.55,365.46l-.65-.77c5.91-5,16.51-6.21,17-6.26l.11,1C54.86,359.43,44.22,360.64,38.55,365.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.09,289.07s1.75,4.09,5.26,3.21,4.38-6.13,9.93-4.67,10.23,7.89,10.23,5-7-10.51-14.9-10.51S86.38,285.27,86.09,289.07Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,293.83c-.67,0-1.56-.68-3-1.75-1.82-1.39-4.31-3.29-7-4-3.16-.83-4.63.66-6.19,2.25a7.77,7.77,0,0,1-3.5,2.43c-3.1.77-5.17-2-5.84-3.51a.59.59,0,0,1,0-.23c.38-5,4.09-7.48,11-7.48,8,0,15.4,7.58,15.4,11a1.24,1.24,0,0,1-.54,1.17A.9.9,0,0,1,111.07,293.83Zm-11.61-7a7.59,7.59,0,0,1,2,.27c2.84.75,5.42,2.72,7.31,4.17a12,12,0,0,0,2.27,1.53,1.29,1.29,0,0,0,0-.25c0-2.45-6.48-10-14.4-10-6.34,0-9.62,2.11-10,6.43.29.62,1.84,3.52,4.63,2.82a6.91,6.91,0,0,0,3-2.16C95.56,288.31,97,286.85,99.46,286.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.52,375.14a38.77,38.77,0,0,0-1.3-4.22c-5-13.39-16.76-11.33-17.25-11.24l-.19-1c.13,0,13.06-2.33,18.38,11.87a40.12,40.12,0,0,1,1.33,4.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.38,345.66s2.63-5.85,12.86-2.05,14.31,9.64,7.88,11.69S109.38,345.66,109.38,345.66Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.45,356c-7.06,0-18.84-9.55-19.39-10a.51.51,0,0,1-.14-.59c0-.06,3-6.22,13.49-2.31,6.93,2.58,11.37,6.19,11.3,9.2,0,1.08-.64,2.55-3.43,3.44A6.32,6.32,0,0,1,128.45,356ZM110,345.54c2.17,1.71,14.38,11,19.94,9.28,1.23-.39,2.71-1.14,2.74-2.51,0-2-3.26-5.49-10.65-8.23C113.83,341,110.77,344.42,110,345.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.85,351.92c-4.76-5.87-15-5.39-15.11-5.38l0-1c.44,0,10.85-.52,15.93,5.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87,347.3l-.4-.91a16.45,16.45,0,0,1,9-1.22l-.18,1A15.9,15.9,0,0,0,100.87,347.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.22,335.53c-6-6.09-11.92-7.1-12-7.11s-8.82-2.28-12.09.72l-.68-.74c3.67-3.37,12.6-1.06,13-1,.2,0,6.27,1,12.49,7.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.06,
    y: 300.34,
    width: 1,
    height: 2.5,
    transform: "translate(-64.34 21.39) rotate(-12.62)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.56,432l-1,0c0-.51,1.29-50.47,0-65.55s-7.34-32.88-7.4-33.06l-6.24-27.85,1-.22,6.22,27.8c0,.13,6.14,18.08,7.44,33.25S79.57,431.49,79.56,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.26,
    y: 311.91,
    width: 2.66,
    height: 1,
    transform: "translate(-222.13 275.71) rotate(-64.94)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.61,431.93h-1c0-.46.46-46.08,2.19-59.06s8.69-33.5,8.76-33.71l10.74-23,.9.42-10.72,23c0,.16-7,20.58-8.69,33.48S82.62,431.47,82.61,431.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.23,432l-1-.06C86,402.59,89,376.19,89,375.93l1,.11C90,376.31,87,402.68,85.23,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.19,431.94l-1,0c0-.41.85-42-.85-47.48-.58-1.9-1.37-3-2.27-3.31a1.89,1.89,0,0,0-1.6.37l-.12.09-.15,0c-.08,0-7.88,1-10.64,5.4l-.85-.52c2.84-4.55,10.11-5.7,11.24-5.85a2.82,2.82,0,0,1,2.39-.47c1.26.36,2.26,1.7,3,4C76.05,389.82,75.23,430.22,75.19,431.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.38,432l-1-.05c0-.41,2.07-41-.17-53.56l1-.18C79.46,390.91,77.4,431.58,77.38,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.42,432c0-2.48-.54-61.05,4.67-74.95a18.86,18.86,0,0,1,6.82-9.24l.57.83A17.78,17.78,0,0,0,92,357.39c-5.15,13.72-4.62,74-4.61,74.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3,432l-1-.13c1.23-9-1.26-61.31-8.27-81.47a41.11,41.11,0,0,0-7.32-13.22l.76-.65A42,42,0,0,1,73,350.06C80,370.34,82.54,422.93,81.3,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.61,431.93h-1c0-.51.31-51.23.73-76.29h1C82.92,380.7,82.62,431.42,82.61,431.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.39,352.49l-1,0c.35-20.21.68-34.34,1-42,.76-19.68,1.84-21.52,2.36-21.83.48-1.1,2.83-5.13,11.1-4.59l-.07,1c-8.52-.54-10.12,4-10.18,4.17l-.25.75-.17-.17c-.37,1.08-1.19,5.17-1.79,20.72C84.07,318.16,83.74,332.28,83.39,352.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.71,371.62s-7.3-6.51-4.38-9.72,21-5.55,26.3-1.38-6.43,10-10.81,11.32S73.17,372.69,71.71,371.62Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,373.13c-2.49,0-4.62-.42-5.56-1.1l0,0c-.21-.19-5-4.55-5.23-8.06a3.12,3.12,0,0,1,.81-2.37c3.17-3.48,21.48-5.79,27-1.45a3.32,3.32,0,0,1,1.46,3.35c-.77,3.93-9.1,7.87-12.44,8.85A22.19,22.19,0,0,1,77,373.13Zm-5-1.9c1.31.93,6.33,1.39,10.65.13,3.66-1.07,11.12-4.9,11.74-8.08a2.36,2.36,0,0,0-1.1-2.37c-5-3.93-22.84-1.71-25.62,1.33a2.18,2.18,0,0,0-.56,1.65C67.3,366.89,71.71,370.94,72,371.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,368.23h-1a13.45,13.45,0,0,1,.16-2l1,.15A12.9,12.9,0,0,0,78.8,368.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.58,363.66l-1-.28a34,34,0,0,1,1.9-4.92l.9.45A32.56,32.56,0,0,0,79.58,363.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.71,414.21s-7.3-6.51-4.38-9.72,21-5.55,26.3-1.38-6.43,10-10.81,11.32S73.17,415.28,71.71,414.21Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,415.72c-2.49,0-4.62-.42-5.56-1.1,0,0,0,0,0,0-.21-.18-5-4.54-5.23-8.05a3.12,3.12,0,0,1,.81-2.37c3.17-3.48,21.48-5.8,27-1.45a3.32,3.32,0,0,1,1.46,3.35c-.77,3.93-9.1,7.87-12.44,8.85A22.19,22.19,0,0,1,77,415.72Zm-5-1.9c1.31.93,6.33,1.39,10.65.13,3.66-1.07,11.12-4.9,11.74-8.08a2.36,2.36,0,0,0-1.1-2.37c-5-3.93-22.84-1.71-25.62,1.33a2.18,2.18,0,0,0-.56,1.65C67.3,409.47,71.71,413.53,72,413.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,410.82h-1c0-4.27,2.61-9.55,2.72-9.77l.9.45C81.39,401.55,78.8,406.79,78.8,410.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,396.2s-5-4.42-3-6.6,14.28-3.77,17.85-.94-4.36,6.81-7.34,7.68S78.14,396.92,77.15,396.2Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,397.38a7.54,7.54,0,0,1-3.89-.78l0,0c-.14-.12-3.48-3.13-3.61-5.58a2.3,2.3,0,0,1,.6-1.72c2.17-2.39,14.75-4,18.53-1a2.38,2.38,0,0,1,1,2.42c-.56,2.9-6.56,5.55-8.56,6.13A14.8,14.8,0,0,1,80.75,397.38Zm-3.29-1.57c.86.59,4.25.88,7.09.06,2.45-.72,7.45-3.27,7.86-5.37a1.46,1.46,0,0,0-.69-1.45c-3.33-2.64-15.31-1.15-17.17.89a1.31,1.31,0,0,0-.34,1C74.3,392.62,76.57,395,77.46,395.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.12,393.9h-1A18.15,18.15,0,0,1,83,387.19l.89.45S82.12,391.2,82.12,393.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.29,
    y: 424.68,
    width: 19.77,
    height: 43.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.06,469H70.29a.5.5,0,0,1-.5-.5V424.68a.5.5,0,0,1,.5-.5H90.06a.5.5,0,0,1,.5.5v43.85A.5.5,0,0,1,90.06,469Zm-19.27-1H89.56V425.18H70.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--screen-3--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.85,
    y: 60.42,
    width: 201.26,
    height: 149.7,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.1,210.62H491.85a.5.5,0,0,1-.5-.5V60.42a.5.5,0,0,1,.5-.5H693.1a.5.5,0,0,1,.5.5v149.7A.5.5,0,0,1,693.1,210.62Zm-200.75-1H692.6V60.92H492.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.56,
    y: 64.67,
    width: 189.83,
    height: 141.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.39,206.37H497.56a.5.5,0,0,1-.5-.5V64.67a.51.51,0,0,1,.5-.5H687.39a.5.5,0,0,1,.5.5v141.2A.5.5,0,0,1,687.39,206.37Zm-189.33-1H686.89V65.17H498.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.47,90.82H506.78a.5.5,0,0,1,0-1h20.69a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.47,95.42H506.78a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.69a.5.5,0,0,1,.5.5A.5.5,0,0,1,527.47,95.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.47,100H506.78a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.69a.5.5,0,0,1,.5.5A.5.5,0,0,1,527.47,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653,182.92h-20.7a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H653a.5.5,0,0,1,.5.5A.51.51,0,0,1,653,182.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653,187.52h-20.7a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H653a.5.5,0,0,1,.5.5A.51.51,0,0,1,653,187.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653,192.12h-20.7a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H653a.5.5,0,0,1,.5.5A.51.51,0,0,1,653,192.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.47,157.11H506.78a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.69a.5.5,0,0,1,.5.5A.5.5,0,0,1,527.47,157.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.47,161.71H506.78a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.69a.5.5,0,0,1,.5.5A.5.5,0,0,1,527.47,161.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.47,166.3H506.78a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.69a.5.5,0,0,1,.5.5A.5.5,0,0,1,527.47,166.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.73,82.24a48.11,48.11,0,1,0,48.1,48.1A48.1,48.1,0,0,0,622.73,82.24Zm0,67.41A19.31,19.31,0,1,1,642,130.34,19.3,19.3,0,0,1,622.73,149.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.73,179a48.61,48.61,0,1,1,48.6-48.61A48.66,48.66,0,0,1,622.73,179Zm0-96.21a47.61,47.61,0,1,0,47.6,47.6A47.65,47.65,0,0,0,622.73,82.74Zm0,67.41a19.81,19.81,0,1,1,19.81-19.81A19.82,19.82,0,0,1,622.73,150.15Zm0-38.62a18.81,18.81,0,1,0,18.81,18.81A18.83,18.83,0,0,0,622.73,111.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "622.73 130.34 587.53 85.17 608.65 75.79 622.73 130.34",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.73,130.84a.5.5,0,0,1-.4-.19L587.14,85.48a.48.48,0,0,1-.09-.43.47.47,0,0,1,.28-.33l21.12-9.39a.48.48,0,0,1,.42,0,.47.47,0,0,1,.26.32l14.08,54.56a.49.49,0,0,1-.26.57A.44.44,0,0,1,622.73,130.84ZM588.32,85.37l33.32,42.77L608.31,76.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "622.73 130.34 578.15 168.47 588.71 176.69 622.73 130.34",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.71,177.19a.49.49,0,0,1-.31-.11l-10.56-8.21a.51.51,0,0,1-.19-.39.49.49,0,0,1,.17-.39L622.4,130a.5.5,0,0,1,.67,0,.49.49,0,0,1,.06.66l-34,46.34a.5.5,0,0,1-.34.2Zm-9.77-8.74,9.67,7.53,31.15-42.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "622.73 130.34 665.55 176.69 680.8 138.56 622.73 130.34",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.55,177.19a.5.5,0,0,1-.37-.17l-42.82-46.34a.5.5,0,0,1-.07-.57.48.48,0,0,1,.51-.26l58.07,8.21a.51.51,0,0,1,.37.25.54.54,0,0,1,0,.43L666,176.87a.49.49,0,0,1-.37.31ZM624.05,131l41.33,44.73L680.1,139Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "591.64 78.72 588.71 72.86 514.79 72.86 514.79 84.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.79,85.09a.51.51,0,0,1-.5-.5V72.85a.51.51,0,0,1,.5-.5h73.92a.5.5,0,0,1,.44.28l2.94,5.87a.51.51,0,0,1-.23.67.5.5,0,0,1-.67-.23l-2.79-5.59H515.29V84.59A.5.5,0,0,1,514.79,85.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "578.73 174.93 572.87 180.79 514.79 180.79 514.79 171.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.87,181.29H514.79a.5.5,0,0,1-.5-.5v-9.38a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.88h57.37l5.72-5.72a.5.5,0,0,1,.71.71l-5.87,5.87A.5.5,0,0,1,572.87,181.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.34,187.74a.5.5,0,0,1-.5-.5v-27a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v27A.5.5,0,0,1,657.34,187.74Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--screen-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.37,
    y: 60.42,
    width: 220.51,
    height: 149.7,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.88,210.62H266.37a.5.5,0,0,1-.5-.5V60.42a.5.5,0,0,1,.5-.5H486.88a.5.5,0,0,1,.5.5v149.7A.5.5,0,0,1,486.88,210.62Zm-220-1H486.38V60.92H266.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.63,
    y: 64.67,
    width: 207.99,
    height: 141.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.62,206.37h-208a.5.5,0,0,1-.5-.5V64.67a.5.5,0,0,1,.5-.5h208a.51.51,0,0,1,.5.5v141.2A.5.5,0,0,1,480.62,206.37Zm-207.49-1h207V65.17h-207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.16,183.41H285.83a.5.5,0,0,1,0-1H470.16a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.79,184.18a.51.51,0,0,1-.5-.5v-3.07a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.07A.5.5,0,0,1,295.79,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.21,184.18a.5.5,0,0,1-.5-.5v-3.07a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v3.07A.51.51,0,0,1,309.21,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.62,184.18a.5.5,0,0,1-.5-.5v-3.07a.5.5,0,0,1,1,0v3.07A.5.5,0,0,1,322.62,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,184.18a.51.51,0,0,1-.5-.5v-3.07a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.07A.5.5,0,0,1,336,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44,184.18a.51.51,0,0,1-.5-.5v-3.07a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.07A.5.5,0,0,1,349.44,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.86,184.18a.5.5,0,0,1-.5-.5v-3.07a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v3.07A.51.51,0,0,1,362.86,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.27,184.18a.5.5,0,0,1-.5-.5v-3.07a.5.5,0,0,1,1,0v3.07A.5.5,0,0,1,376.27,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.68,184.18a.51.51,0,0,1-.5-.5v-3.07a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.07A.5.5,0,0,1,389.68,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.1,184.18a.5.5,0,0,1-.5-.5v-3.07a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v3.07A.51.51,0,0,1,403.1,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.51,184.18a.5.5,0,0,1-.5-.5v-3.07a.5.5,0,0,1,1,0v3.07A.5.5,0,0,1,416.51,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.92,184.18a.51.51,0,0,1-.5-.5v-3.07a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.07A.5.5,0,0,1,429.92,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.34,184.18a.5.5,0,0,1-.5-.5v-3.07a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v3.07A.51.51,0,0,1,443.34,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.75,184.18a.5.5,0,0,1-.5-.5v-3.07a.5.5,0,0,1,1,0v3.07A.5.5,0,0,1,456.75,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.64,176.9a.52.52,0,0,1-.43-.24l-13.38-21.93L396.62,173.6a.49.49,0,0,1-.34.22.48.48,0,0,1-.4-.1L383.1,163.19,369.6,170a.5.5,0,0,1-.65-.19l-12.33-20.17L344.8,160.67,328.66,172.2a.48.48,0,0,1-.49.06L315.71,167l-14.37,5.68a.51.51,0,0,1-.65-.29.5.5,0,0,1,.28-.64L315.54,166a.5.5,0,0,1,.38,0l12.39,5.26,15.86-11.34,12.21-11.45a.52.52,0,0,1,.41-.13.49.49,0,0,1,.36.23l12.41,20.31,13.39-6.7a.51.51,0,0,1,.54.06l12.59,10.38,12.35-19.08a.5.5,0,0,1,.42-.22h0a.49.49,0,0,1,.42.24l13.58,22.25L437,170.21l13.35-10.31a.51.51,0,0,1,.7.1.5.5,0,0,1-.09.7L437.51,171a.37.37,0,0,1-.12.07l-14.56,5.75A.43.43,0,0,1,422.64,176.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.17,191.08a.51.51,0,0,1-.35-.15L369,177.13l-12.61-17.94L344.3,155l-15.81-8.27L316.1,161a.48.48,0,0,1-.2.14l-14.56,5.75A.5.5,0,0,1,301,166l14.45-5.71L328,145.79a.5.5,0,0,1,.61-.11l16.09,8.43,12.2,4.18a.53.53,0,0,1,.25.19l12.64,18,13.28,13.27,12.7-22.42a.5.5,0,0,1,.65-.21l12.5,5.68,13.47-2.62,14.45-16.35a.52.52,0,0,1,.39-.17l13.41.38a.5.5,0,1,1,0,1l-13.18-.37L423,171a.53.53,0,0,1-.28.16l-13.8,2.68a.51.51,0,0,1-.3,0l-12.23-5.56L383.6,190.82a.47.47,0,0,1-.36.25Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.62,
    y: 93.38,
    width: 8.08,
    height: 40.88,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.7,134.76h-8.08a.5.5,0,0,1-.5-.5V93.38a.5.5,0,0,1,.5-.5h8.08a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,293.7,134.76Zm-7.58-1h7.08V93.88h-7.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.43,
    y: 108.89,
    width: 8.07,
    height: 25.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.5,134.76h-8.07a.5.5,0,0,1-.5-.5V108.89a.5.5,0,0,1,.5-.5h8.07a.5.5,0,0,1,.5.5v25.37A.5.5,0,0,1,305.5,134.76Zm-7.57-1H305V109.39h-7.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.23,
    y: 111.63,
    width: 8.08,
    height: 22.63,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.3,134.76h-8.07a.5.5,0,0,1-.5-.5V111.63a.5.5,0,0,1,.5-.5h8.07a.5.5,0,0,1,.5.5v22.63A.5.5,0,0,1,317.3,134.76Zm-7.57-1h7.07V112.13h-7.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.03,
    y: 105.24,
    width: 8.08,
    height: 29.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.11,134.76H321a.5.5,0,0,1-.5-.5v-29a.5.5,0,0,1,.5-.5h8.08a.5.5,0,0,1,.5.5v29A.5.5,0,0,1,329.11,134.76Zm-7.58-1h7.08v-28h-7.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.83,
    y: 104.33,
    width: 8.08,
    height: 29.93,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.91,134.76h-8.08a.5.5,0,0,1-.5-.5V104.33a.5.5,0,0,1,.5-.5h8.08a.5.5,0,0,1,.5.5v29.93A.5.5,0,0,1,340.91,134.76Zm-7.58-1h7.08V104.83h-7.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.63,
    y: 83.95,
    width: 8.08,
    height: 50.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.71,134.76h-8.08a.5.5,0,0,1-.5-.5V84a.5.5,0,0,1,.5-.5h8.08a.5.5,0,0,1,.5.5v50.31A.5.5,0,0,1,352.71,134.76Zm-7.58-1h7.08V84.45h-7.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.44,
    y: 106.76,
    width: 8.08,
    height: 27.5,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.51,134.76h-8.07a.5.5,0,0,1-.5-.5v-27.5a.5.5,0,0,1,.5-.5h8.07a.5.5,0,0,1,.5.5v27.5A.5.5,0,0,1,364.51,134.76Zm-7.57-1H364v-26.5h-7.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.24,
    y: 98.85,
    width: 8.08,
    height: 35.41,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.31,134.76h-8.07a.5.5,0,0,1-.5-.5V98.85a.5.5,0,0,1,.5-.5h8.07a.5.5,0,0,1,.5.5v35.41A.5.5,0,0,1,376.31,134.76Zm-7.57-1h7.07V99.35h-7.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.04,
    y: 117.1,
    width: 8.07,
    height: 17.16,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.12,134.76H380a.5.5,0,0,1-.5-.5V117.1a.5.5,0,0,1,.5-.5h8.08a.51.51,0,0,1,.5.5v17.16A.5.5,0,0,1,388.12,134.76Zm-7.58-1h7.08V117.6h-7.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.15,
    y: 88.08,
    width: 52.23,
    height: 6.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.38,94.67H422.15a.5.5,0,0,1-.5-.5V88.08a.5.5,0,0,1,.5-.5h52.23a.5.5,0,0,1,.5.5v6.09A.5.5,0,0,1,474.38,94.67Zm-51.73-1h51.23V88.58H422.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.15,
    y: 98.1,
    width: 52.23,
    height: 6.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.38,104.69H422.15a.5.5,0,0,1-.5-.5V98.1a.5.5,0,0,1,.5-.5h52.23a.5.5,0,0,1,.5.5v6.09A.5.5,0,0,1,474.38,104.69Zm-51.73-1h51.23V98.6H422.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.15,
    y: 108.12,
    width: 52.23,
    height: 6.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.38,114.72H422.15a.5.5,0,0,1-.5-.5v-6.1a.5.5,0,0,1,.5-.5h52.23a.5.5,0,0,1,.5.5v6.1A.51.51,0,0,1,474.38,114.72Zm-51.73-1h51.23v-5.1H422.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.15,
    y: 118.14,
    width: 52.23,
    height: 6.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.38,124.74H422.15a.5.5,0,0,1-.5-.5v-6.1a.5.5,0,0,1,.5-.5h52.23a.51.51,0,0,1,.5.5v6.1A.5.5,0,0,1,474.38,124.74Zm-51.73-1h51.23v-5.1H422.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.15,
    y: 128.16,
    width: 52.23,
    height: 6.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.38,134.76H422.15a.5.5,0,0,1-.5-.5v-6.1a.5.5,0,0,1,.5-.5h52.23a.51.51,0,0,1,.5.5v6.1A.5.5,0,0,1,474.38,134.76Zm-51.73-1h51.23v-5.1H422.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.15,
    y: 88.08,
    width: 31.54,
    height: 6.1,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.68,94.67H422.15a.5.5,0,0,1-.5-.5V88.08a.5.5,0,0,1,.5-.5h31.53a.5.5,0,0,1,.5.5v6.09A.5.5,0,0,1,453.68,94.67Zm-31-1h30.53V88.58H422.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.15,
    y: 98.1,
    width: 20.8,
    height: 6.1,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,104.69h-20.8a.5.5,0,0,1-.5-.5V98.1a.5.5,0,0,1,.5-.5H443a.5.5,0,0,1,.5.5v6.09A.5.5,0,0,1,443,104.69Zm-20.3-1h19.8V98.6h-19.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.15,
    y: 108.12,
    width: 45.71,
    height: 6.1,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.86,114.72H422.15a.5.5,0,0,1-.5-.5v-6.1a.5.5,0,0,1,.5-.5h45.71a.5.5,0,0,1,.5.5v6.1A.5.5,0,0,1,467.86,114.72Zm-45.21-1h44.71v-5.1H422.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.15,
    y: 118.14,
    width: 41.5,
    height: 6.1,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.65,124.74h-41.5a.5.5,0,0,1-.5-.5v-6.1a.5.5,0,0,1,.5-.5h41.5a.51.51,0,0,1,.5.5v6.1A.5.5,0,0,1,463.65,124.74Zm-41-1h40.5v-5.1h-40.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.15,
    y: 128.16,
    width: 34.6,
    height: 6.1,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.75,134.76h-34.6a.5.5,0,0,1-.5-.5v-6.1a.5.5,0,0,1,.5-.5h34.6a.5.5,0,0,1,.5.5v6.1A.5.5,0,0,1,456.75,134.76Zm-34.1-1h33.6v-5.1h-33.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.32,73.81h-20.7a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.7a.5.5,0,0,1,.5.5A.51.51,0,0,1,306.32,73.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.32,78.41h-20.7a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.7a.5.5,0,0,1,.5.5A.51.51,0,0,1,306.32,78.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.32,83h-20.7a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.7a.5.5,0,0,1,.5.5A.51.51,0,0,1,306.32,83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.19,73.81h-20.7a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.7a.5.5,0,0,1,.5.5A.51.51,0,0,1,443.19,73.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.19,78.41h-20.7a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.7a.5.5,0,0,1,.5.5A.51.51,0,0,1,443.19,78.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.19,83h-20.7a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.7a.5.5,0,0,1,.5.5A.51.51,0,0,1,443.19,83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--screen-1--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.76,
    y: 60.42,
    width: 201.26,
    height: 149.7,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,210.62H60.76a.5.5,0,0,1-.5-.5V60.42a.51.51,0,0,1,.5-.5H262a.5.5,0,0,1,.5.5v149.7A.5.5,0,0,1,262,210.62Zm-200.76-1H261.52V60.92H61.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.48,
    y: 64.67,
    width: 189.83,
    height: 141.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.3,206.37H66.48a.5.5,0,0,1-.5-.5V64.67a.5.5,0,0,1,.5-.5H256.3a.5.5,0,0,1,.5.5v141.2A.5.5,0,0,1,256.3,206.37ZM67,205.37H255.8V65.17H67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,146.23H211.87a.5.5,0,0,1,0-1h20.69a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,150.83H211.87a.5.5,0,0,1,0-1h20.69a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,155.43H211.87a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.69a.5.5,0,0,1,.5.5A.5.5,0,0,1,232.56,155.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.38,81.81H77.69a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H98.38a.5.5,0,0,1,.5.5A.5.5,0,0,1,98.38,81.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.38,86.4H77.69a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H98.38a.5.5,0,0,1,.5.5A.5.5,0,0,1,98.38,86.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.38,91H77.69a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H98.38a.5.5,0,0,1,.5.5A.5.5,0,0,1,98.38,91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7,186.28a.5.5,0,0,1-.5-.5V114.5a.5.5,0,0,1,.5-.5H222.25a.51.51,0,0,1,.5.5.5.5,0,0,1-.5.5H94.2v70.78A.5.5,0,0,1,93.7,186.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.32,130.84a.5.5,0,0,1-.5-.5V99a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v31.38A.5.5,0,0,1,222.32,130.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.87,126.53a.5.5,0,0,1-.5-.5v-11.1a.5.5,0,0,1,1,0V126A.5.5,0,0,1,178.87,126.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.65,114.54a.51.51,0,0,1-.5-.5V102.93a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V114A.5.5,0,0,1,160.65,114.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,126.53a.5.5,0,0,1-.5-.5v-11.1a.5.5,0,0,1,1,0V126A.5.5,0,0,1,136.66,126.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.27,
    y: 80.48,
    width: 42.24,
    height: 21.7,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51,102.69H140.27a.51.51,0,0,1-.5-.5V80.48a.5.5,0,0,1,.5-.5h42.24a.5.5,0,0,1,.5.5v21.71A.5.5,0,0,1,182.51,102.69Zm-41.74-1H182V81H140.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.01,
    y: 120.37,
    width: 35.39,
    height: 18.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.39,139.06H76a.5.5,0,0,1-.5-.5V120.37a.5.5,0,0,1,.5-.5h35.38a.5.5,0,0,1,.5.5v18.19A.5.5,0,0,1,111.39,139.06Zm-34.88-1h34.38V120.87H76.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.01,
    y: 148.53,
    width: 35.39,
    height: 18.18,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.39,167.21H76a.5.5,0,0,1-.5-.5V148.53a.5.5,0,0,1,.5-.5h35.38a.5.5,0,0,1,.5.5v18.18A.5.5,0,0,1,111.39,167.21Zm-34.88-1h34.38V149H76.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.01,
    y: 176.69,
    width: 35.39,
    height: 18.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.39,195.37H76a.5.5,0,0,1-.5-.5V176.69a.5.5,0,0,1,.5-.5h35.38a.5.5,0,0,1,.5.5v18.18A.5.5,0,0,1,111.39,195.37Zm-34.88-1h34.38V177.19H76.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.88,
    y: 120.37,
    width: 35.39,
    height: 18.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27,139.06H118.88a.5.5,0,0,1-.5-.5V120.37a.5.5,0,0,1,.5-.5h35.39a.5.5,0,0,1,.5.5v18.19A.51.51,0,0,1,154.27,139.06Zm-34.89-1h34.39V120.87H119.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.76,
    y: 120.37,
    width: 35.39,
    height: 18.18,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.14,139.06H161.76a.5.5,0,0,1-.5-.5V120.37a.5.5,0,0,1,.5-.5h35.38a.5.5,0,0,1,.5.5v18.19A.5.5,0,0,1,197.14,139.06Zm-34.88-1h34.38V120.87H162.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.63,
    y: 120.37,
    width: 35.39,
    height: 18.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,139.06H204.63a.5.5,0,0,1-.5-.5V120.37a.5.5,0,0,1,.5-.5H240a.5.5,0,0,1,.5.5v18.19A.51.51,0,0,1,240,139.06Zm-34.89-1h34.39V120.87H205.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.63,
    y: 89.87,
    width: 35.39,
    height: 18.18,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,108.55H204.63a.5.5,0,0,1-.5-.5V89.87a.5.5,0,0,1,.5-.5H240a.5.5,0,0,1,.5.5v18.18A.5.5,0,0,1,240,108.55Zm-34.89-1h34.39V90.37H205.13Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568,248.85s-5.23-16.61-5.23-16.95-1-6.26-1.71-7.63-5-5-5-5l-1.82,20.36,3,3.07,2.85,2.62.79,8.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.85,254a.54.54,0,0,1-.21,0,.49.49,0,0,1-.28-.4l-.78-8-2.71-2.49-3-3.09a.52.52,0,0,1-.14-.39l1.82-20.36a.48.48,0,0,1,.31-.42.5.5,0,0,1,.51.08c.45.38,4.42,3.74,5.13,5.16s1.76,7.45,1.76,7.85,3.17,10.33,5.21,16.79a.51.51,0,0,1-.21.57l-7.16,4.67A.57.57,0,0,1,560.85,254Zm-6.08-14.56,2.8,2.91L560.4,245a.48.48,0,0,1,.15.32l.72,7.37,6.16-4c-3.41-10.83-5.14-16.46-5.14-16.73a44.94,44.94,0,0,0-1.66-7.4c-.43-.87-2.71-3-4.14-4.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.69,
    y: 214.12,
    width: 12.47,
    height: 26.39,
    transform: "translate(-21.07 60.09) rotate(-6.11)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.13,241.59a.49.49,0,0,1-.49-.44l-2.81-26.24a.47.47,0,0,1,.1-.36.53.53,0,0,1,.34-.19l12.4-1.33a.51.51,0,0,1,.55.45L560,239.71a.53.53,0,0,1-.11.37.48.48,0,0,1-.33.18l-12.4,1.33Zm-2.26-26.29,2.71,25.24,11.4-1.22-2.7-25.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.24,237.24a70.06,70.06,0,0,0-2-7.39c-.56-1-3.64-3.87-4.77-6s-2.51-.23-2.51,2.39,2.73,3.87,2.73,3.87.8,6.59,1.37,7.39a30,30,0,0,0,2.5,2.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.51,240.59a.51.51,0,0,1-.34-.14,28.58,28.58,0,0,1-2.57-2.69c-.56-.79-1.19-5.54-1.42-7.36a5,5,0,0,1-2.77-4.19c0-1.63.53-3.5,1.69-3.79.37-.09,1.11-.07,1.76,1.17a24.32,24.32,0,0,0,3.12,4,14.51,14.51,0,0,1,1.65,2c.59,1,2,6.86,2.1,7.52a.5.5,0,0,1-.37.6.49.49,0,0,1-.6-.37,62.72,62.72,0,0,0-2-7.27,15.2,15.2,0,0,0-1.53-1.84,24.52,24.52,0,0,1-3.26-4.2c-.26-.5-.51-.68-.63-.66-.33.08-.93,1.09-.93,2.82,0,2.27,2.42,3.4,2.44,3.41a.49.49,0,0,1,.29.4c.38,3.16,1,6.7,1.28,7.16a27.92,27.92,0,0,0,2.43,2.54.5.5,0,0,1,0,.71A.54.54,0,0,1,560.51,240.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.92,203.08s-2.15,4.85-1.26,6.82-.18,4.31-1.25,5.75-2.16,2.87-.9,4.13,2.33,2.15,2.33,2.15,1.62,8.79,3,9.69,6.82.18,6.82.18l1.08,7.72,19.92-4.31-3.59-12.92s-2.87-15.08-8.07-20.82S573.25,200,570.92,203.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.79,240a.47.47,0,0,1-.28-.09.48.48,0,0,1-.21-.34l-1-7.23c-1.45.16-5.34.51-6.66-.31-1.49-.94-2.9-8-3.25-9.85-.33-.29-1.21-1.06-2.22-2.07-1.57-1.56-.23-3.35.85-4.78.52-.7,2.15-3.14,1.2-5.24s1-6.71,1.25-7.23l.06-.1c1.59-2.08,6.35-4.43,10.91-4.62a9.83,9.83,0,0,1,8,3c5.24,5.78,8.08,20.44,8.2,21.07l3.58,12.88a.54.54,0,0,1-.06.39.5.5,0,0,1-.32.23L580.9,240Zm-1.07-8.72a.5.5,0,0,1,.49.43l1,7.19,18.88-4.09-3.45-12.41c0-.19-2.91-15-8-20.61a9,9,0,0,0-7.21-2.65c-4.18.17-8.66,2.33-10.12,4.18-.58,1.34-1.88,4.93-1.23,6.36,1.18,2.6-.71,5.44-1.31,6.25-1.29,1.72-1.8,2.62-.95,3.47,1.23,1.23,2.29,2.12,2.3,2.13a.52.52,0,0,1,.18.29c.77,4.22,2,8.87,2.82,9.36.93.58,4.48.37,6.49.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.15,231.62s-.18-.18,1.44-.9a15.94,15.94,0,0,0,3.77-3.05l.35,4.13S575.41,231.62,574.15,231.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.71,232.3h0s-4.31-.18-5.54-.18a.47.47,0,0,1-.35-.15.54.54,0,0,1-.15-.47c.05-.27.22-.56,1.73-1.23a15.55,15.55,0,0,0,3.61-2.94.5.5,0,0,1,.53-.13.49.49,0,0,1,.33.43l.36,4.13a.48.48,0,0,1-.13.39A.51.51,0,0,1,579.71,232.3Zm-3.87-1.14c1.18,0,2.56.09,3.33.12L579,228.8A13.15,13.15,0,0,1,575.84,231.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.38,193.39s-3.41-.89-7.54,2.34-5.56,7.71-4.12,8.43,7.53.72,7.53.72-.71,2.69.54,4a4.88,4.88,0,0,0,2.34,1.43s-.72,2.88,0,3.41c0,0,1.61-3,2.51-2.87s1.61,3.77,1.61,5.21a17.74,17.74,0,0,0,3,7.54c1.44,1.61,7,4.12,9.52,3.58s5.38-2.15,5.56-2.69,6.1-6.46,6.46-12.2,1.08-12.21-3.77-16-8.43-6.46-8.43-6.46-3.59-3.41-5.39-2.51a10.82,10.82,0,0,0-3.23,2.87,6.68,6.68,0,0,0-7.54-.72C572.36,191.78,577.38,193.39,577.38,193.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.05,227.71c-2.93,0-7.73-2.27-9.12-3.83a18.11,18.11,0,0,1-3.18-7.87c0-1.61-.75-4.48-1.23-4.72a7.44,7.44,0,0,0-1.95,2.62.49.49,0,0,1-.34.25.48.48,0,0,1-.4-.09c-.77-.57-.53-2.37-.3-3.47a5.93,5.93,0,0,1-2.09-1.42c-1.05-1.05-.94-2.85-.8-3.8-1.65,0-5.88-.14-7.15-.77a1.53,1.53,0,0,1-.8-1.33c-.19-1.89,1.57-5.38,4.85-7.95a11.37,11.37,0,0,1,5.7-2.5,2.19,2.19,0,0,1-.88-1.4c-.08-.85.55-1.67,1.88-2.42a7.1,7.1,0,0,1,7.69.46,10.69,10.69,0,0,1,3.1-2.63c2.05-1,5.56,2.23,6,2.6h0s3.61,2.71,8.4,6.43,4.38,10,4,15.45l-.06,1c-.3,4.77-4.21,9.55-5.88,11.59-.28.34-.57.69-.62.78-.27.82-3.49,2.46-5.92,3A3.94,3.94,0,0,1,592.05,227.71ZM578.57,210.3h.17c1.46.29,2,4.8,2,5.7a17.23,17.23,0,0,0,2.93,7.2c1.36,1.53,6.72,3.93,9,3.44a12.9,12.9,0,0,0,5.21-2.4,5.14,5.14,0,0,1,.76-1c1.61-2,5.39-6.56,5.66-11l.06-1c.36-5.51.74-11.2-3.63-14.6-4.79-3.72-8.4-6.43-8.43-6.46-1.34-1.26-3.79-3-4.86-2.46a10.2,10.2,0,0,0-3.05,2.72.55.55,0,0,1-.35.2.54.54,0,0,1-.39-.12,6.11,6.11,0,0,0-7-.66c-.93.52-1.41,1-1.37,1.45.07.69,1.5,1.37,2.18,1.59a.5.5,0,0,1-.28,1c-.06,0-3.26-.77-7.11,2.24-3.27,2.56-4.6,5.73-4.47,7.06,0,.19.08.45.26.53,1.09.55,5.65.67,7.31.67a.5.5,0,0,1,.49.63c-.18.67-.45,2.6.41,3.46a4.44,4.44,0,0,0,2.06,1.3.52.52,0,0,1,.33.22.5.5,0,0,1,.07.39,11.13,11.13,0,0,0-.3,2C577,211.33,577.8,210.3,578.57,210.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.31,220.9a2.35,2.35,0,0,1-.76-.12.5.5,0,0,1,.38-.93,1.38,1.38,0,0,0,1.29-.28c.43-.35.61-2.11.53-3.53a.5.5,0,0,1,.48-.53.49.49,0,0,1,.52.47c0,.58.14,3.53-.9,4.37A2.46,2.46,0,0,1,578.31,220.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.3,238.26l-.89,6.1s10.41-3.58,16-5.38,14.18-.9,14.18-.9l-2.33-6.1s-6.82-1.43-12.39.72S576.3,238.26,576.3,238.26Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.41,244.86a.46.46,0,0,1-.32-.11.51.51,0,0,1-.18-.46l.9-6.1a.49.49,0,0,1,.32-.39s9-3.41,14.53-5.57,12.39-.8,12.67-.74a.49.49,0,0,1,.36.31l2.34,6.1a.53.53,0,0,1-.07.49.52.52,0,0,1-.45.19c-.09,0-8.58-.87-14,.88s-15.86,5.34-16,5.38A.44.44,0,0,1,575.41,244.86Zm1.35-6.23-.74,5c2.52-.86,10.58-3.62,15.21-5.12s11.29-1.16,13.58-1l-1.95-5.1c-1.3-.23-7.09-1.09-11.84.75C586,235.1,578.3,238,576.76,238.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.56,312.57s-4.31,35.18-.72,57.79,10.23,49,12.93,59.05,3.41,23.51,3.41,23.51-1.44,1.26-1.44,2.15a29.06,29.06,0,0,0,.18,4.13c.18.54-2.51,2.69-5.92,4.49s-8.08,2.51-8.26,3.95-.54,1.25,6.1,3.41,20.64.36,20.64.36,4.85.72,6.46.18a2.54,2.54,0,0,0,1.62-2.34s7,.9,9.15.36,2-4.31,1.62-7.72-2.33-24.94-2-36.43-4.84-37-4.84-37l7-46.31S611.66,326,610.59,321a43.45,43.45,0,0,1-1.08-8.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.32,472.61a33.42,33.42,0,0,1-9.63-1.09l-.78-.25c-5.69-1.84-5.91-1.91-5.69-3.49l0-.2c.14-1.17,1.87-1.78,4.27-2.62a30.07,30.07,0,0,0,4.24-1.71c3.28-1.72,5.38-3.49,5.65-4a26.59,26.59,0,0,1-.17-4.18,4.1,4.1,0,0,1,1.42-2.36c-.11-1.84-.92-14-3.38-23.17-.89-3.33-8.83-33.29-12.93-59.1-3.56-22.43.67-57.58.72-57.93a.5.5,0,0,1,.49-.44h0l46,.18a.5.5,0,0,1,.5.5,43.52,43.52,0,0,0,1.06,8.15c1.09,5.05-1,20.68-1.06,21.35l-7,46.22c.33,1.66,5.18,25.93,4.83,37-.35,11.25,1.58,32.62,2,36.36s.58,7.62-2,8.26c-1.9.47-7.18-.09-8.84-.29a2.85,2.85,0,0,1-1.9,2.25c-1.62.54-5.87,0-6.62-.15A99.34,99.34,0,0,1,579.32,472.61ZM564,313.07c-.48,4.14-4,36.29-.67,57.21,4.09,25.76,12,55.67,12.91,59,2.67,10,3.42,23.48,3.43,23.61a.55.55,0,0,1-.17.41c-.51.45-1.27,1.32-1.27,1.77a23.31,23.31,0,0,0,.15,4c.51,1.53-6.09,5.06-6.16,5.09a31.69,31.69,0,0,1-4.38,1.78c-1.58.55-3.54,1.23-3.61,1.79l0,.22c-.11.74-.11.74,5,2.4l.78.25c6.46,2.1,20.28.36,20.42.34a.65.65,0,0,1,.14,0c1.31.2,5,.61,6.23.2a2,2,0,0,0,1.27-1.86.5.5,0,0,1,.56-.49c.07,0,6.93.87,9,.37,1.71-.43,1.59-3.87,1.24-7.18-.39-3.76-2.33-25.2-2-36.51s-4.78-36.6-4.83-36.85a1.09,1.09,0,0,1,0-.18l7-46.3c0-.15,2.13-16.12,1.09-21a46.82,46.82,0,0,1-1.08-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.84,465.8a.5.5,0,0,1-.5-.44c0-.22-2.51-22.47-2.51-38.82a83.63,83.63,0,0,0-3.3-24.3c-.71-2.72-1.44-5.53-2.08-8.81-2.14-11.08,1.29-41.92,1.43-43.23a.52.52,0,0,1,.21-.35l6.1-4.48a.5.5,0,1,1,.59.8l-5.93,4.36c-.3,2.83-3.44,32.26-1.41,42.71.63,3.25,1.35,6,2,8.74a84.11,84.11,0,0,1,3.34,24.56c0,16.29,2.48,38.49,2.51,38.71a.5.5,0,0,1-.44.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.2,244s-18.48,7.89-18.3,9.69S553.51,311,553.51,311s1.44,1.62,5.92,2.51a16.12,16.12,0,0,0,7.36,0s3.59,3.24,19,3.24,23.15-2.52,23.69-3.95.54-4.67.54-7.18,6.82-40.92,7-41.82,1.43-15.08.54-18.31-12-7.36-12-7.36a67.33,67.33,0,0,0-13.64-.36C583.84,238.26,577.2,244,577.2,244Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.82,317.2c-13.58,0-18.13-2.49-19.13-3.19a17.36,17.36,0,0,1-7.35-.05c-4.6-.92-6.14-2.6-6.2-2.68a.48.48,0,0,1-.13-.38c1.55-15.39,5.52-55.66,5.39-57.15-.19-1.87,11.5-7.17,18.54-10.17.73-.62,7.11-5.83,14.95-6.35a67.66,67.66,0,0,1,13.75.36c1.26.46,11.49,4.34,12.43,7.72s-.35,17.61-.53,18.54c-.45,2.24-7,39.37-7,41.72,0,2.6,0,5.83-.57,7.35C609.19,315,599.94,317.2,585.82,317.2Zm-19-4.24a.55.55,0,0,1,.34.13s3.75,3.11,18.69,3.11c15.57,0,22.82-2.56,23.22-3.63.51-1.35.51-4.62.51-7,0-2.69,6.94-41.57,7-41.92.18-.9,1.4-15,.54-18.07-.68-2.45-8.69-5.9-11.71-7h0a69,69,0,0,0-13.44-.33c-7.81.52-14.36,6.11-14.42,6.16a.38.38,0,0,1-.13.09c-8.54,3.64-17.61,8.1-18,9.25.18,1.71-4.9,52.52-5.36,57a12.21,12.21,0,0,0,5.5,2.21,15.88,15.88,0,0,0,7.11,0ZM577.2,244h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.76,270.27l-.12,0a.51.51,0,0,1-.37-.61l.7-2.78a.51.51,0,0,1,.61-.37.5.5,0,0,1,.36.61l-.7,2.79A.5.5,0,0,1,577.76,270.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.79,314h-.12a.5.5,0,0,1-.36-.61l10-39.9a.51.51,0,0,1,.61-.36.5.5,0,0,1,.36.61l-10,39.9A.5.5,0,0,1,566.79,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.28,286.15a.54.54,0,0,1-.3-.1.5.5,0,0,1-.1-.7c3.39-4.56,7.16-10.5,9.73-14.68a.49.49,0,0,1,.69-.17.51.51,0,0,1,.16.69c-2.58,4.2-6.37,10.17-9.78,14.75A.49.49,0,0,1,592.28,286.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.41,269.17a.5.5,0,0,1-.26-.08.49.49,0,0,1-.17-.68c.9-1.49,1.43-2.4,1.43-2.4a.5.5,0,0,1,.86.5s-.53.92-1.43,2.41A.51.51,0,0,1,603.41,269.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.77,291.53a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7c.53-.53,9.77-10.3,9.86-10.4a.5.5,0,0,1,.71,0,.49.49,0,0,1,0,.7c-.38.41-9.34,9.89-9.88,10.42A.5.5,0,0,1,589.77,291.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.61,314.9s.36,32,.72,34.64,1.26,8.44,1.62,10.95.71,5.38,1.43,5.74,4,2.69,5,2.51,2.51-1.07,2.15-2.33-2.15-1.61-2.15-1.61a30.69,30.69,0,0,1,.18-5.39c.36-2.15,1.07-2.87.18-6.46a36,36,0,0,0-2.7-7l6.29-28.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.29,369.25c-.95,0-2.49-.92-4.24-2-.4-.25-.72-.46-.89-.54-.82-.41-1.14-2.1-1.64-5.61l-.07-.51c-.14-1-.37-2.52-.62-4.15-.37-2.46-.78-5.18-1-6.8-.36-2.7-.71-33.4-.73-34.7a.51.51,0,0,1,.19-.4.53.53,0,0,1,.42-.1l12.75,2.88a.49.49,0,0,1,.37.59l-6.24,28a36.58,36.58,0,0,1,2.65,6.95,9.21,9.21,0,0,1,.11,5.37c-.1.39-.2.8-.28,1.29a28.53,28.53,0,0,0-.19,4.92,3.09,3.09,0,0,1,2.15,1.86,1.82,1.82,0,0,1-.23,1.55,3.54,3.54,0,0,1-2.32,1.42Zm-8.17-53.72c0,4.5.38,31.52.71,33.94.21,1.62.62,4.33,1,6.79.25,1.63.48,3.15.62,4.16l.07.51c.25,1.7.65,4.54,1.1,4.86.18.09.54.31,1,.59.93.59,3.1,2,3.74,1.87a2.6,2.6,0,0,0,1.64-1,.85.85,0,0,0,.11-.74c-.27-.94-1.75-1.26-1.77-1.26a.51.51,0,0,1-.4-.47,30.67,30.67,0,0,1,.18-5.49c.09-.52.2-1,.3-1.37a8.3,8.3,0,0,0-.11-4.89,35.68,35.68,0,0,0-2.65-6.89.49.49,0,0,1,0-.34l6.17-27.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.54,304.31a20.43,20.43,0,0,0,7.71,3.77,28.17,28.17,0,0,0,9.34.72s-.72,7.72-1.62,9.33-4.31,2.15-9,.54-6.46-2.33-6.64-3.41S551.54,304.31,551.54,304.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.14,320.15a16.48,16.48,0,0,1-5.3-1c-5-1.72-6.75-2.45-7-3.8-.18-1.09.14-10,.18-11a.49.49,0,0,1,.3-.44.54.54,0,0,1,.53.08,19.88,19.88,0,0,0,7.51,3.67,27.93,27.93,0,0,0,9.15.7.49.49,0,0,1,.41.14.53.53,0,0,1,.15.4c-.08.8-.76,7.87-1.68,9.53C566.76,319.55,565.21,320.15,563.14,320.15ZM552,305.3c-.13,3.91-.27,9.18-.15,9.88s2.49,1.7,6.31,3c4.52,1.56,7.63,1,8.37-.31.64-1.15,1.25-6.09,1.5-8.54a28.81,28.81,0,0,1-8.9-.79A21.86,21.86,0,0,1,552,305.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.15,368.69s1.75,15.43,2.23,18.15l1.15,6.54s-1.07,17.25,2.39,31.05,7.69,28.5,7.64,29.95a25.15,25.15,0,0,1-1.31,4.91s-4.14,4.35-7.12,6-5,1.63-5.17,2.9,2.67,1.46,3.43,1.27,16.7,0,16.7,0,3.21.37,3.68-1.45.1-8.71-.25-10a48.7,48.7,0,0,1-.91-6.9c.08-.55-1.1-32.32-.3-40.86s-1.12-21.78-1.12-21.78l2.15-18.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.68,470a4.62,4.62,0,0,1-2.81-.77,1.24,1.24,0,0,1-.41-1.13c.17-1.06,1.15-1.44,2.5-2a23,23,0,0,0,2.93-1.31c2.67-1.46,6.37-5.25,6.92-5.82a22.37,22.37,0,0,0,1.25-4.65c0-.78-1.51-6.53-3.28-13.19-1.36-5.11-2.91-10.91-4.35-16.63-3.33-13.31-2.46-30-2.4-31.14l-1.14-6.48c-.48-2.71-2.17-17.56-2.24-18.19a.47.47,0,0,1,.14-.4.45.45,0,0,1,.39-.15l23.19,1.45a.5.5,0,0,1,.47.56l-2.15,18.27c.15,1,1.88,13.65,1.11,21.84-.6,6.48-.06,26.31.2,35.84.11,4.07.13,4.88.1,5a52.7,52.7,0,0,0,.9,6.69c.36,1.31.75,8.31.25,10.25-.57,2.21-4.07,1.84-4.22,1.82-6.24-.07-15.86-.13-16.53,0A3.56,3.56,0,0,1,469.68,470Zm-2-100.79c.33,2.86,1.74,15.16,2.16,17.54l1.16,6.53a.48.48,0,0,1,0,.12c0,.17-1,17.33,2.38,30.89,1.43,5.72,3,11.51,4.33,16.62,2.2,8.25,3.35,12.6,3.32,13.48a25.17,25.17,0,0,1-1.34,5.06.62.62,0,0,1-.11.17c-.17.18-4.22,4.43-7.24,6.09a22.46,22.46,0,0,1-3.05,1.36c-1.21.47-1.8.71-1.87,1.18a.24.24,0,0,0,.1.24,4.31,4.31,0,0,0,2.72.47c.78-.19,14.15-.05,16.83,0,.07,0,2.84.28,3.18-1.07.45-1.73.08-8.55-.24-9.73a48.31,48.31,0,0,1-.93-7.11c0-.19,0-2.25-.11-4.86-.26-9.55-.8-29.43-.19-36,.78-8.38-1.1-21.54-1.12-21.67v-.13l2.09-17.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.19,463.9a17.63,17.63,0,0,1-2.06,1.38c-3,1.63-5,1.63-5.17,2.9s2.67,1.46,3.43,1.27,16.7,0,16.7,0,3.21.37,3.68-1.45a21,21,0,0,0,.2-4.38l-14.75,2.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.68,470a4.62,4.62,0,0,1-2.81-.77,1.24,1.24,0,0,1-.41-1.13c.17-1.06,1.15-1.44,2.5-2a23,23,0,0,0,2.93-1.31,15.43,15.43,0,0,0,2-1.34.5.5,0,0,1,.65,0l1.86,1.76,14.51-2.17a.48.48,0,0,1,.4.12.47.47,0,0,1,.17.37,21.39,21.39,0,0,1-.22,4.52c-.57,2.21-4.07,1.84-4.22,1.82-6.24-.07-15.86-.13-16.53,0A3.56,3.56,0,0,1,469.68,470Zm4.47-5.46a15.72,15.72,0,0,1-1.78,1.17,22.46,22.46,0,0,1-3.05,1.36c-1.21.47-1.8.71-1.87,1.18a.24.24,0,0,0,.1.24,4.31,4.31,0,0,0,2.72.47c.78-.19,14.15-.05,16.83,0,.07,0,2.84.28,3.18-1.07a16.94,16.94,0,0,0,.2-3.68l-14.18,2.12a.52.52,0,0,1-.42-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.2,367.6S482.62,379,483,384.44s8.5,65.95,8.78,69.94,1.81,9.26,2.05,12.35,2.83,4,4.53,4.72,5.68,2,6.56-3.63-4.91-13.8-5.45-16.16,3.4-27.42,3.94-36.68-.31-20-1.16-23.78a39.41,39.41,0,0,1-1-6.72l6.89-17.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.15,472.61a7.53,7.53,0,0,1-2.95-.7l-.29-.12c-1.7-.72-4.28-1.8-4.53-5a50.31,50.31,0,0,0-.9-5.24,56.1,56.1,0,0,1-1.16-7.11c-.13-1.88-2-16.48-4-31.94-2.23-17.27-4.54-35.13-4.76-38-.42-5.48,3-16.56,3.19-17a.48.48,0,0,1,.46-.35l22-.37h0a.49.49,0,0,1,.41.22.47.47,0,0,1,.05.47l-6.84,17.15a39.91,39.91,0,0,0,.92,6.52c.84,3.74,1.74,14.41,1.18,23.92-.25,4.33-1.23,12-2.17,19.36-1,7.87-2,16-1.78,17.18a20.33,20.33,0,0,0,1.51,3.31c1.83,3.55,4.59,8.92,3.94,13-.33,2.12-1.13,3.55-2.38,4.24A3.93,3.93,0,0,1,501.15,472.61ZM486.57,368.09c-.58,1.94-3.4,11.54-3,16.31.21,2.85,2.52,20.7,4.75,38,2,15.47,3.89,30.08,4,32a57.08,57.08,0,0,0,1.14,7,48.47,48.47,0,0,1,.91,5.36c.21,2.61,2.27,3.48,3.93,4.18l.29.12c1.68.72,3,.81,4,.27s1.59-1.72,1.88-3.52c.59-3.79-2.08-9-3.85-12.42a21.11,21.11,0,0,1-1.6-3.55c-.28-1.26.48-7.46,1.76-17.52,1-7.38,1.92-15,2.17-19.29.56-9.42-.33-20-1.15-23.65a40.32,40.32,0,0,1-1-6.81.45.45,0,0,1,0-.2l6.61-16.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505,467.82c.37-2.33-.42-5.1-1.5-7.71a17.42,17.42,0,0,1-.47,4.08c-.51.91-4.07,1.63-5.71,1.63a11.13,11.13,0,0,1-3.65-.94c.11.67.2,1.3.24,1.85.25,3.09,2.83,4,4.53,4.72S504.08,473.45,505,467.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.15,472.61a7.53,7.53,0,0,1-2.95-.7l-.29-.12c-1.7-.72-4.28-1.8-4.53-5,0-.46-.12-1-.25-1.8a.51.51,0,0,1,.69-.55,10.92,10.92,0,0,0,3.46.9c1.85,0,5-.81,5.27-1.37,0-.08.25-.62.41-3.87a.5.5,0,0,1,.41-.47.51.51,0,0,1,.55.3c1.36,3.29,1.86,5.9,1.53,8s-1.13,3.55-2.38,4.24A3.93,3.93,0,0,1,501.15,472.61Zm-6.89-6.95c.05.4.09.73.11,1,.21,2.61,2.27,3.48,3.93,4.18l.29.12c1.68.72,3,.81,4,.27s1.59-1.72,1.87-3.52h0a11.63,11.63,0,0,0-.66-5.27,4.89,4.89,0,0,1-.38,2c-.68,1.23-4.66,1.89-6.14,1.89A9.51,9.51,0,0,1,494.26,465.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.57,232.36s-8.28-1.05-12.35-.6-11.75,2.11-11.75,2.11l-15.82.9L435.1,228l-6.32,8.14s8.43,10.09,12.5,11.3S466,249.54,466,249.54s-.15,7.68.75,10.54S467.8,281,468,284.49s-4.82,15.82-5.13,16.42-4.67,9.64-4.82,25.91,5.88,46.1,5.88,46.1h44.9s7.09-20.76,7.55-40.95-3.79-29-6.65-37.24-.9-12.5-.9-12.5-1.81-5,.45-14.31,7.23-18.53,7.53-21-19.43-13.1-19.43-13.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.78,373.42h-44.9a.49.49,0,0,1-.49-.4c-.06-.3-6-30.06-5.89-46.2.16-16.49,4.68-25.75,4.88-26.13.43-.87,5.21-12.9,5.07-16.18,0-.8-.07-2.37-.12-4.35-.13-6.22-.39-17.79-1.06-19.93-.8-2.51-.81-8.46-.79-10.22-3.21-.14-20.56-1-24.34-2.1-4.17-1.24-12.4-11-12.75-11.46a.51.51,0,0,1,0-.63l6.33-8.14a.5.5,0,0,1,.66-.11l10.41,6.69,15.66-.89s7.68-1.66,11.72-2.11,12.14.56,12.48.6h0l11.75,1.51a.49.49,0,0,1,.17.06c4.7,2.55,20,11.06,19.7,13.61a32.41,32.41,0,0,1-2.13,5.75A102.47,102.47,0,0,0,509.71,268c-2.19,9.06-.48,14-.46,14a.55.55,0,0,1,0,.38s-1.83,4.17.92,12.13c.34,1,.7,2,1.07,3,2.68,7.37,6,16.55,5.61,34.41-.45,20-7.51,40.9-7.58,41.11A.5.5,0,0,1,508.78,373.42Zm-44.49-1h44.13c.9-2.76,7-22,7.41-40.46.39-17.68-2.76-26.37-5.55-34-.37-1-.73-2-1.07-3-2.6-7.51-1.32-11.76-1-12.69-.31-1-1.55-5.92.5-14.41a103,103,0,0,1,5.47-15.4,32.63,32.63,0,0,0,2-5.49c0-1.37-9.91-7.58-19.09-12.56l-11.66-1.49c-.11,0-8.28-1.05-12.23-.6s-11.63,2.08-11.71,2.1l-15.89.91a.46.46,0,0,1-.3-.08l-10.16-6.53-5.8,7.45c1.44,1.69,8.51,9.8,12,10.84,4,1.17,24.38,2.08,24.59,2.09a.5.5,0,0,1,.48.51c0,.07-.14,7.63.73,10.38.72,2.28,1,13.5,1.11,20.21.05,2,.08,3.53.12,4.33.15,3.62-4.92,16.15-5.18,16.66s-4.62,9.44-4.77,25.7C458.36,341.84,463.58,368.82,464.29,372.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.07,231.91s-2,2.56-2.87,3.92-3.91,12-3.91,12l8.43-1.51,10.85,4.52s4.67-10.24,3.77-14.76-5.73-5.12-5.73-5.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.57,251.39a.43.43,0,0,1-.19,0l-10.71-4.46-8.29,1.48a.49.49,0,0,1-.46-.16.47.47,0,0,1-.11-.47c.31-1.1,3.06-10.81,4-12.19s2.8-3.84,2.88-3.94a.47.47,0,0,1,.35-.2l10.55-.9h.11c.05,0,5.19.7,6.15,5.52.92,4.62-3.61,14.65-3.8,15.07A.52.52,0,0,1,496.57,251.39Zm-10.85-5.52a.65.65,0,0,1,.2,0l10.39,4.33c.87-2,4.3-10.22,3.54-14s-4.74-4.64-5.25-4.72l-10.27.88c-.45.6-2,2.59-2.71,3.71-.59.9-2.42,6.89-3.63,11.15l7.65-1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.1,199.37a10.67,10.67,0,0,0-2.57,5.57c-.3,3.17,0,5.58-.6,6.48s-5.87,4.82-5.57,5.72,3.31,3.17,3.31,3.17,1.51,8.89,2.41,9.34,5.28-.3,5.28-.3a32.26,32.26,0,0,1,2.41,5.27c.75,2.41.6,13.11,2,11.75s9.35-11.45,9.95-13.56,0-6.48,0-6.48,5.27-5.87,5.12-13.86-7.68-13.55-12.2-14.91S479.1,199.37,479.1,199.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.5,247a.65.65,0,0,1-.24,0c-.79-.3-1-1.83-1.38-6.94a35.75,35.75,0,0,0-.59-5.24,29.9,29.9,0,0,0-2.2-4.87c-1.34.22-4.35.64-5.23.2s-1.94-5.38-2.65-9.51c-.87-.67-3-2.37-3.33-3.29-.25-.76.71-1.76,3.71-4.37a18.52,18.52,0,0,0,1.93-1.79,7.73,7.73,0,0,0,.35-2.95c0-1,.05-2.07.17-3.3a11,11,0,0,1,2.69-5.86.25.25,0,0,1,.1-.08c.21-.14,5.21-3.28,9.9-1.87,5,1.49,12.41,7.42,12.56,15.38a22.39,22.39,0,0,1-5.1,14c.12.94.51,4.53,0,6.46-.66,2.29-8.87,12.58-10.07,13.78A.84.84,0,0,1,485.5,247Zm-4.14-18.14a.5.5,0,0,1,.43.25,31.92,31.92,0,0,1,2.45,5.37,32.68,32.68,0,0,1,.63,5.46,37.73,37.73,0,0,0,.69,5.89c1.89-2,9.11-11.33,9.63-13.14.56-2,0-6.23,0-6.28a.5.5,0,0,1,.13-.4c.05-.06,5.14-5.83,5-13.52-.14-7.47-7.15-13-11.85-14.44-4-1.2-8.48,1.39-9,1.72A10.13,10.13,0,0,0,477,205c-.11,1.19-.14,2.27-.16,3.22,0,1.63-.07,2.81-.52,3.49a17,17,0,0,1-2.11,2c-1.15,1-3.29,2.86-3.4,3.39a16.76,16.76,0,0,0,3.13,2.83.57.57,0,0,1,.2.32c.67,4,1.69,8.52,2.18,9,.42.21,2.9,0,4.92-.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.77,191.08s-11.15,3.47-9.95,5.88,11.45,11,11.45,11l1.66,2.72s-.45,2.26.6,2.71,3.47-3.62,3.47-3.62a4.69,4.69,0,0,1,3.91,5.43c-.45,4.82-2.86,6.32-2.86,6.32s2.86,4.52,3.62,4.82,6.63-4.67,10.39-9.79,3.92-9.49,1.66-13.86-5.42-9-11.75-10.7A36,36,0,0,0,483.77,191.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.68,226.83a.6.6,0,0,1-.2,0c-.81-.33-3-3.62-3.85-5a.56.56,0,0,1-.07-.38.48.48,0,0,1,.23-.31s2.21-1.47,2.63-6a4.17,4.17,0,0,0-3.18-4.82c-1,1.67-2.7,4-3.9,3.52s-1-2.42-.94-3.07l-1.51-2.48c-.95-.8-10.31-8.71-11.51-11.11a1.36,1.36,0,0,1,0-1.2c1.05-2.45,9.32-5.08,10.26-5.38l.08,0a36.21,36.21,0,0,1,12.4.92c6.52,1.71,9.76,6.5,12.07,10.95,2.5,4.84,2,9.41-1.7,14.39C503.31,221.13,497.35,226.83,495.68,226.83Zm-3-5.21a28,28,0,0,0,3.08,4.21c1.05-.31,6.26-4.69,9.86-9.58,3.46-4.7,4-8.82,1.62-13.34-2.21-4.26-5.29-8.83-11.44-10.44a35.82,35.82,0,0,0-12-.9c-3.38,1.06-8.94,3.28-9.59,4.81a.36.36,0,0,0,0,.35c1,1.9,8.5,8.47,11.32,10.84l.11.12,1.66,2.72a.53.53,0,0,1,.06.35c-.13.65-.17,2,.31,2.16h0c.42,0,1.78-1.62,2.84-3.41a.48.48,0,0,1,.5-.24,5.22,5.22,0,0,1,4.34,6C495.05,219.1,493.47,221,492.72,221.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.91,201.48a7.82,7.82,0,0,1,3.62-2.87c2.56-1.05,6.93-.15,8,1.36s2.87,6.18,2.26,9.64-5.12,7.23-7.08,7.23-5-1.8-6.17-5.42S505.91,201.48,505.91,201.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.69,217.34c-2.29,0-5.4-2-6.65-5.76s-.65-9.89-.62-10.15a.42.42,0,0,1,.06-.21,8.26,8.26,0,0,1,3.86-3.07c2.67-1.1,7.32-.27,8.58,1.53s3,6.46,2.35,10C519.62,213.41,514.88,217.34,512.69,217.34Zm-6.29-15.7c-.07.88-.48,6.42.59,9.62,1.17,3.51,4,5.08,5.7,5.08s6-3.49,6.59-6.81-1.12-7.76-2.18-9.27c-.9-1.3-5-2.16-7.38-1.18A7.55,7.55,0,0,0,506.4,201.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.08,221.86a.5.5,0,0,1-.07-1,7.85,7.85,0,0,0,3.23-1.4.49.49,0,0,1,.7.07.51.51,0,0,1-.08.71,8.89,8.89,0,0,1-3.7,1.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.1,210.82c0,.87-.31,1.58-.68,1.58s-.68-.71-.68-1.58.3-1.58.68-1.58S479.1,209.94,479.1,210.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.3,208.15a.51.51,0,0,1-.43-.24c-.23-.4-.48-.62-.73-.64a1.29,1.29,0,0,0-.88.42.5.5,0,0,1-.74-.67,2.23,2.23,0,0,1,1.72-.75,2,2,0,0,1,1.49,1.13.51.51,0,0,1-.18.69A.54.54,0,0,1,480.3,208.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.83,224.27a.39.39,0,0,1-.15,0,.49.49,0,0,1-.32-.63l.9-2.72a.51.51,0,0,1,.54-.33l3.32.45a.5.5,0,0,1,.43.56.52.52,0,0,1-.57.43l-2.9-.4-.77,2.32A.5.5,0,0,1,487.83,224.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.36 229.35 484.52 228.9 483.16 232.96 481.36 229.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.16,233.46a.48.48,0,0,1-.44-.27l-1.81-3.62a.51.51,0,0,1,0-.45.53.53,0,0,1,.38-.27l3.16-.45a.49.49,0,0,1,.45.18.47.47,0,0,1,.09.47l-1.35,4.07a.51.51,0,0,1-.44.34Zm-1.05-3.72,1,1.92.72-2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.76,247s2.11-.45,3.77,13.56,2.65,28.75,3.16,29.68c.64,1.18-5.1,2.6-7.83,3.47a49.54,49.54,0,0,1-6.18,1.05l-2.11-8.13,5.57-2-3.91-16.72S513.9,251.34,516.76,247Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.68,295.23a.5.5,0,0,1-.49-.37l-2.1-8.14a.49.49,0,0,1,.31-.59l5.16-1.81L508.74,268a.43.43,0,0,1,0-.25c.19-.68,4.72-16.7,7.59-21.08a.47.47,0,0,1,.32-.21.85.85,0,0,1,.71.2c1.44,1,2.71,5.8,3.65,13.79.79,6.66,1.43,13.46,1.94,18.92s.94,10.05,1.17,10.59a.88.88,0,0,1,0,.76c-.43,1-3,1.86-6.56,2.92-.59.17-1.14.34-1.6.49a50.62,50.62,0,0,1-6.27,1.07Zm-1.51-8.31,1.88,7.26a44,44,0,0,0,5.66-1c.46-.15,1-.31,1.62-.49,1.83-.54,5.66-1.68,5.91-2.34-.28-.45-.56-3.19-1.28-10.88-.51-5.45-1.14-12.24-1.93-18.9-1.18-10-2.57-12.4-3.09-13-2.67,4.55-6.77,18.82-7.2,20.3l3.89,16.59a.5.5,0,0,1-.32.59Zm8.56-39.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.44 286 473.67 277.11 479.7 275.9 482.71 285.39 477.44 286",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.44,286.5a.5.5,0,0,1-.46-.31l-3.77-8.89a.5.5,0,0,1,0-.43.51.51,0,0,1,.34-.25l6-1.21a.5.5,0,0,1,.57.34l3,9.49a.52.52,0,0,1-.06.42.49.49,0,0,1-.36.23l-5.27.6Zm-3.07-9,3.38,8,4.3-.5-2.69-8.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.1,288l-14.16.76a59,59,0,0,0-3.31-5.13c-.45-.3-5.12-1.8-5.12-1.8l.9,2.56-8.44,1.2a5.12,5.12,0,0,0,.61,2.41,2.82,2.82,0,0,0,2.11.91,57.35,57.35,0,0,0,5.72,4.22c1.51.75,5.42.6,5.42.6l18.08,2.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.91,296.44h-.06l-18.08-2.26c-.08,0-4,.16-5.58-.65a51.47,51.47,0,0,1-5.69-4.17,3.12,3.12,0,0,1-2.34-1.12,5.65,5.65,0,0,1-.69-2.69.5.5,0,0,1,.43-.49l7.84-1.12-.71-2a.51.51,0,0,1,.63-.64c1.11.36,4.77,1.55,5.25,1.87a37.54,37.54,0,0,1,3.31,5l13.86-.74a.49.49,0,0,1,.51.39l1.81,8a.51.51,0,0,1-.49.61Zm-18.1-3.26,17.46,2.17-1.56-6.88-13.74.74a.5.5,0,0,1-.46-.25,56.61,56.61,0,0,0-3.18-5c-.23-.14-2.09-.78-4-1.41l.57,1.6a.5.5,0,0,1,0,.43.49.49,0,0,1-.36.23l-8,1.14a4.09,4.09,0,0,0,.49,1.71,2.3,2.3,0,0,0,1.7.68.51.51,0,0,1,.31.11,58.69,58.69,0,0,0,5.63,4.16C483.77,293.2,486.76,293.22,487.81,293.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.77 284.34 501.85 286.45 506.21 296.99 511.94 295.94 508.77 284.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.21,297.49a.5.5,0,0,1-.46-.31l-4.37-10.54a.53.53,0,0,1,0-.41.51.51,0,0,1,.31-.26l6.93-2.11a.5.5,0,0,1,.63.35l3.16,11.6a.45.45,0,0,1-.06.39.46.46,0,0,1-.33.23l-5.73,1.06Zm-3.69-10.73,4,9.67,4.79-.89L508.43,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.6,226.64l-20.64-19s-7.23-8.58-10.85-10.54-5.88-2-5.27-.45,2.86,2.41,2.86,2.41l2.86,2.86s-.15,5.87.76,7.38,4.82,2.41,4.82,2.41l2.41.9,16.27,21.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.82,234.82h0a.51.51,0,0,1-.38-.2L410.23,213l-2.27-.85c-.36-.08-4.09-1-5.07-2.62-.88-1.47-.85-6.25-.83-7.44l-2.64-2.64c-.48-.21-2.44-1.14-3.05-2.65a1.17,1.17,0,0,1,.22-1.42c.82-.73,3-.26,5.76,1.25,3.66,2,10.69,10.31,11,10.66l20.6,18.94a.5.5,0,0,1,0,.7l-6.78,7.68A.48.48,0,0,1,426.82,234.82ZM397.7,196.07a.72.72,0,0,0-.45.1.5.5,0,0,0,.05.3c.52,1.29,2.56,2.12,2.59,2.13a.46.46,0,0,1,.16.11l2.87,2.86a.5.5,0,0,1,.14.37c0,1.6,0,6,.68,7.11s3.48,1.95,4.51,2.18l2.47.93a.48.48,0,0,1,.23.17l15.9,21.2,6-6.86L412.62,208c-.12-.13-7.26-8.58-10.75-10.47A10,10,0,0,0,397.7,196.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,210.82s-1.51-5.43-2.71-7.23-2.87-3.77-3.47-5.28-.15-4.52-.9-4.37-2.41.3-2.41,2.56a13.77,13.77,0,0,0,1.5,5.13s0,5.42,1.36,7.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,211.32a.5.5,0,0,1-.48-.37s-1.5-5.37-2.65-7.09c-.38-.57-.81-1.16-1.24-1.75a18.7,18.7,0,0,1-2.27-3.61,8.87,8.87,0,0,1-.42-2.69,9.06,9.06,0,0,0-.13-1.34c-.82.15-1.8.37-1.8,2a13.05,13.05,0,0,0,1.45,4.89.69.69,0,0,1,.05.24c0,1.46.23,5.52,1.25,6.76a.52.52,0,0,1-.07.71.51.51,0,0,1-.71-.08c-1.35-1.65-1.46-6.31-1.47-7.27a13.84,13.84,0,0,1-1.5-5.25,2.8,2.8,0,0,1,2.66-3l.15,0a.73.73,0,0,1,.59.14c.42.33.47,1.06.53,2.16a8.8,8.8,0,0,0,.34,2.38,19.47,19.47,0,0,0,2.16,3.4c.44.59.87,1.19,1.26,1.78,1.24,1.85,2.72,7.15,2.78,7.37a.51.51,0,0,1-.35.62Zm-7-16.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.18,201.31s-.33,1.9.11,2.45,3.68,1.67,4.24.67.33-2.45-.56-2.78S401,200.42,400.18,201.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.51,205.33a6.21,6.21,0,0,1-3.61-1.25c-.54-.68-.3-2.36-.21-2.85a.58.58,0,0,1,.12-.25c.95-1.09,3-.3,4.15.13l.18.07a1.76,1.76,0,0,1,1,1.1,3,3,0,0,1-.21,2.39,1.36,1.36,0,0,1-1.2.65Zm-2.86-3.77a3.9,3.9,0,0,0,0,1.89,5.58,5.58,0,0,0,3,.87c.23,0,.34-.08.37-.13a2,2,0,0,0,.14-1.57.8.8,0,0,0-.44-.5l-.19-.08C402.94,201.79,401.25,201.14,400.65,201.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.18,204.54s-1.89-.44-1.78.89.22,2.23.78,2.46a8.56,8.56,0,0,0,4-.45,1.44,1.44,0,0,0,.56-2C404.3,205,401.18,204.54,401.18,204.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.06,208.47a3.36,3.36,0,0,1-1.06-.12c-.89-.35-1-1.58-1.1-2.87a1.28,1.28,0,0,1,.42-1.14,2.48,2.48,0,0,1,2-.29c1.22.18,3.33.54,3.82,1a1.44,1.44,0,0,1,.36,1.25,2.14,2.14,0,0,1-1,1.54A8.78,8.78,0,0,1,401.06,208.47Zm-.53-3.5a1,1,0,0,0-.56.13s-.09.08-.07.29c.06.76.16,1.91.47,2a8.68,8.68,0,0,0,3.57-.41,1.15,1.15,0,0,0,.53-.81.58.58,0,0,0-.07-.41,14.14,14.14,0,0,0-3.29-.75h0A2.87,2.87,0,0,0,400.53,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.18,207.89s.34,1.55,1,1.89,3.12.33,3.68-.56-.67-1.78-.67-1.78S400.74,207.77,400.18,207.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.55,210.49a4.14,4.14,0,0,1-1.59-.26c-.84-.42-1.2-1.94-1.27-2.24a.51.51,0,0,1,.07-.38.55.55,0,0,1,.32-.22c.57-.11,3.71-.41,4.06-.45a.5.5,0,0,1,.35.1c.55.4,1.43,1.43.79,2.45A3.28,3.28,0,0,1,402.55,210.49Zm-1.74-2.19a2.14,2.14,0,0,0,.6,1c.54.27,2.66.22,3-.37.22-.36-.19-.8-.41-1C403.2,208,401.66,208.19,400.81,208.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.45 225.28 425.46 234.17 429.38 239.59 438.42 229.2 433.45 225.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.38,240.09h0a.49.49,0,0,1-.39-.2l-3.91-5.43a.5.5,0,0,1,0-.63l8-8.88a.5.5,0,0,1,.69-.06l5,3.91a.53.53,0,0,1,.19.35.58.58,0,0,1-.12.38l-9,10.39A.52.52,0,0,1,429.38,240.09Zm-3.28-5.89,3.32,4.59,8.28-9.52L433.51,226Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.1,234.05s2.42.23,2.86,10.57,2.42,21.14,1.32,30.06-1.54,15.74-2.64,17.62-4.4,2.35-6.16,1.88a15.61,15.61,0,0,1-4.17-2.35l-1.1-4.23Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,294.85a6.38,6.38,0,0,1-1.59-.18,15.89,15.89,0,0,1-4.36-2.44.5.5,0,0,1-.18-.27l-1.1-4.23a.54.54,0,0,1,0-.22l9.9-53.55a.49.49,0,0,1,.54-.41c.48,0,2.87.79,3.31,11,.15,3.5.48,7.1.8,10.58.64,7,1.25,13.62.52,19.57-.29,2.32-.53,4.5-.75,6.49-.66,5.92-1.09,9.84-2,11.32S359.85,294.85,358,294.85Zm-5.2-3.31a14.54,14.54,0,0,0,3.86,2.16c1.6.43,4.64,0,5.6-1.65.76-1.3,1.23-5.54,1.82-10.92.22-2,.47-4.18.75-6.51.72-5.83.12-12.4-.52-19.35-.32-3.49-.65-7.11-.8-10.63-.28-6.67-1.39-9-2-9.73l-9.73,52.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,284.9s7.65,11.7,8.55,12.15a3.29,3.29,0,0,0,4.73-2.92c.45-3.83-3.83-11.25-3.83-11.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.52,297.85a4,4,0,0,1-1.69-.35c-.92-.46-6.43-8.77-8.75-12.33a.5.5,0,0,1,.32-.76l9.45-2a.48.48,0,0,1,.53.24c.18.31,4.36,7.61,3.89,11.56a3.64,3.64,0,0,1-3.75,3.66Zm-9.2-12.61c3.48,5.31,7.36,10.95,8,11.38a3.25,3.25,0,0,0,2.59-.09,3,3,0,0,0,1.39-2.46c.38-3.19-2.79-9.19-3.59-10.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.22,
    y: 283.1,
    width: 42.3,
    height: 2.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53,286.08H281.22a.51.51,0,0,1-.5-.5V283.1a.5.5,0,0,1,.5-.5h42.31a.5.5,0,0,1,.5.5v2.48A.51.51,0,0,1,323.53,286.08Zm-41.81-1H323V283.6H281.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.27 256.77 277.52 256.77 281.33 283.1 315.08 283.1 311.27 256.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.08,283.6H281.33a.51.51,0,0,1-.5-.43L277,256.84a.51.51,0,0,1,.5-.57h33.75a.51.51,0,0,1,.5.43L315.58,283a.49.49,0,0,1-.12.4A.49.49,0,0,1,315.08,283.6Zm-33.32-1H314.5l-3.66-25.33H278.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.75 258.11 279.42 258.11 282.85 281.77 313.18 281.77 309.75 258.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.18,282.27H282.85a.51.51,0,0,1-.5-.43l-3.42-23.66a.49.49,0,0,1,.12-.4.48.48,0,0,1,.37-.17h30.33a.51.51,0,0,1,.5.43l3.42,23.65a.51.51,0,0,1-.11.4A.53.53,0,0,1,313.18,282.27Zm-29.9-1H312.6l-3.28-22.66H280Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,412.49s11.7,42.08,12.38,44.55.22,7.88.67,9.9.23,3.83,2.25,4.06,7,1.35,8.55-1.13-.22-6.3-.9-8.33-2.25-8.77-2.25-8.77,1.58-28.35-1.35-42.53-7-28.13-7-28.13,7.2-13.95,9.22-21.6c0,0-28.13-3.15-28.13,0S327.13,389.31,337,412.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77,472a26,26,0,0,1-3.56-.33l-.93-.13c-2-.22-2.24-1.77-2.48-3.27-.06-.37-.12-.76-.21-1.17a25.84,25.84,0,0,1-.25-4.29,27.2,27.2,0,0,0-.42-5.58c-.66-2.42-12-43.16-12.36-44.52-8.74-20.47-7.18-42.76-6.67-50.09.07-1,.11-1.7.11-2.06a1.07,1.07,0,0,1,.4-.82c2.75-2.46,25.68,0,28.29.32a.55.55,0,0,1,.36.22.54.54,0,0,1,.07.41c-1.9,7.15-8.33,19.87-9.18,21.52.5,1.73,4.22,14.84,6.93,28,2.83,13.73,1.45,41,1.36,42.58.17.72,1.6,6.8,2.23,8.67q.14.42.33.93c.8,2.18,2,5.48.51,7.82C360.4,471.56,358.6,472,356.77,472ZM337.69,359.61c-3.43,0-6,.23-6.63.82-.06.48-.11,1.2-.18,2.21-.5,7.27-2,29.4,6.61,49.65a.14.14,0,0,1,0,.07c.12.42,11.71,42.1,12.38,44.55a27.36,27.36,0,0,1,.45,5.84,25.56,25.56,0,0,0,.23,4.09c.09.42.16.83.22,1.23.25,1.59.41,2.3,1.6,2.43l1,.13c2.21.31,5.91.84,7.1-1s.12-4.94-.61-6.94c-.13-.35-.25-.67-.34-1-.68-2-2.2-8.54-2.26-8.82a.32.32,0,0,1,0-.14c0-.28,1.54-28.45-1.34-42.4s-6.92-27.95-7-28.09a.48.48,0,0,1,0-.37c.07-.13,6.86-13.32,9-20.94C351.88,360.27,343.51,359.61,337.69,359.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.08,466.94c.45,2,.23,3.83,2.25,4.06s7,1.35,8.55-1.13c.9-1.41.7-3.25.24-4.95H349.88A12.22,12.22,0,0,0,350.08,466.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77,472a26,26,0,0,1-3.56-.33l-.93-.13c-2-.22-2.24-1.77-2.48-3.27-.06-.37-.12-.76-.21-1.17h0a13.61,13.61,0,0,1-.21-2.11.5.5,0,0,1,.5-.52h11.24a.5.5,0,0,1,.49.37c.62,2.3.52,4-.31,5.35S358.6,472,356.77,472Zm-6.2-5.11c.09.42.16.83.22,1.23.25,1.59.41,2.3,1.6,2.43l1,.13c2.21.31,5.91.84,7.1-1,.62-1,.71-2.35.27-4.18H350.41a9.23,9.23,0,0,0,.16,1.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.58,363.21l7.87,32.85s-.45,7,1.58,18.45,7.2,45.91,7.2,45.91-2.7,4.5-4.73,6.3-5.62,2.25-4.5,3.6,3.83,1.58,4.5,1.58h12.83s2.25,1.12,2.47-1.8-1.35-8.33-1.35-10.58.45-13,2-25.65,2.48-29,.23-37.58-2.93-12.6-2.93-13.5S336.35,365,336.35,365Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.26,472.61a2.93,2.93,0,0,1-1-.21H321.5s-3.44,0-4.88-1.76a1.18,1.18,0,0,1-.31-1c.16-.73,1.06-1.16,2.19-1.69a11.6,11.6,0,0,0,2.67-1.58,34.18,34.18,0,0,0,4.54-6c-.41-2.7-5.25-34.8-7.17-45.71A89,89,0,0,1,317,396.11l-7.86-32.78a.47.47,0,0,1,.11-.44.44.44,0,0,1,.41-.18l26.78,1.8a.5.5,0,0,1,.35.18.48.48,0,0,1,.11.37c-.43,4.68-1.57,17-1.57,17.73,0,.93.77,5.26,2.91,13.37,2.25,8.57,1.37,25.13-.21,37.77-1.55,12.34-2,23.07-2,25.59a28.21,28.21,0,0,0,.59,4.05,29.19,29.19,0,0,1,.76,6.56,2.59,2.59,0,0,1-1.11,2.24A1.82,1.82,0,0,1,335.26,472.61Zm-25-108.86,7.72,32.2a.61.61,0,0,1,0,.14,86.83,86.83,0,0,0,1.57,18.34c2,11.35,7.15,45.57,7.2,45.91a.5.5,0,0,1-.06.34c-.11.18-2.77,4.58-4.82,6.41a12,12,0,0,1-2.91,1.74c-.63.3-1.59.75-1.64,1a.33.33,0,0,0,.1.17c.95,1.14,3.35,1.4,4.11,1.4h12.83a.42.42,0,0,1,.22.05,1.43,1.43,0,0,0,1.15.05c.43-.24.57-.92.61-1.44a29.32,29.32,0,0,0-.75-6.31,28.25,28.25,0,0,1-.61-4.23c0-2.53.49-13.33,2-25.72,1.57-12.55,2.46-29,.24-37.38-2.32-8.83-2.94-12.72-2.94-13.63s1.26-14.43,1.53-17.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.8,470.1a16,16,0,0,0-.22-3.38H321.5c-2,1.8-5.62,2.25-4.5,3.6s3.83,1.58,4.5,1.58h12.83S336.58,473,336.8,470.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.26,472.61a2.93,2.93,0,0,1-1-.21H321.5s-3.44,0-4.88-1.76a1.18,1.18,0,0,1-.31-1c.16-.73,1.06-1.16,2.19-1.69a11.6,11.6,0,0,0,2.67-1.58.46.46,0,0,1,.33-.13h15.08a.49.49,0,0,1,.49.43,15.53,15.53,0,0,1,.23,3.48l-.5,0,.5,0a2.59,2.59,0,0,1-1.11,2.24A1.82,1.82,0,0,1,335.26,472.61Zm-13.57-5.39a13,13,0,0,1-2.76,1.61c-.63.3-1.59.75-1.64,1a.33.33,0,0,0,.1.17c.95,1.14,3.35,1.4,4.11,1.4h12.83a.42.42,0,0,1,.22.05,1.43,1.43,0,0,0,1.15.05c.43-.24.57-.92.61-1.44a14,14,0,0,0-.17-2.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.38,287.38a134.5,134.5,0,0,0-7,42.75c.23,23.18,4.05,37.35,4.05,37.35a199.13,199.13,0,0,0,27.9,1.8c16.43,0,23-4.5,23-4.5s11.47-30.6,6.52-47.93a155.62,155.62,0,0,0-12.15-30.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,369.79a201.16,201.16,0,0,1-28-1.81.49.49,0,0,1-.4-.37c0-.14-3.85-14.5-4.07-37.47a136.4,136.4,0,0,1,7-42.94.49.49,0,0,1,.46-.32l42.3-.68a.51.51,0,0,1,.45.26,157.4,157.4,0,0,1,12.19,30.26c4.94,17.28-6.06,47-6.53,48.24a.5.5,0,0,1-.19.24C359.32,365.38,352.75,369.79,336.36,369.79ZM308.85,367a205.89,205.89,0,0,0,27.51,1.75c14.82,0,21.55-3.74,22.54-4.34.87-2.38,11.12-31.12,6.45-47.46a157.85,157.85,0,0,0-12-29.78l-41.66.66a135.82,135.82,0,0,0-6.83,42.26C305.11,351.09,308.3,364.82,308.85,367Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.38,230.67s-16.2,7.88-16.2,9.68-3.15,53.1-2.25,54.9,4.05,4.95,7.42,4.95,7.2-2.25,7.88-4.72,2-7.65,2-7.65l34.43-1.13s8.55-45.68,8.55-48.15-.22-3.6-.9-4.5-14.62-4.73-14.62-4.73S325.78,228.42,320.38,230.67Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.35,300.7c-3.72,0-7-3.4-7.87-5.22-.62-1.24.21-18.79,1.75-46.69.26-4.66.45-8,.45-8.44,0-1.91,11.52-7.72,16.48-10.13h0c5.44-2.27,25.68-1.43,26.54-1.39l.11,0c4.24,1.16,14.19,4,14.89,4.91s1,2.2,1,4.8-8.21,46.38-8.56,48.24a.5.5,0,0,1-.47.41l-34.06,1.11c-.32,1.22-1.36,5.22-1.93,7.3C317,298.27,313,300.7,309.35,300.7Zm11.23-69.57c-7.56,3.68-15.58,8.14-15.91,9.25,0,.41-.17,3.61-.44,8.46-.73,13.31-2.46,44.47-1.85,46.21.78,1.56,3.73,4.65,7,4.65s6.78-2.12,7.4-4.35c.67-2.48,2-7.65,2-7.65a.5.5,0,0,1,.47-.37l34-1.12c3-15.89,8.47-45.76,8.47-47.66,0-2.35-.2-3.41-.8-4.2-.62-.56-7.82-2.75-14.3-4.53C345.43,229.77,325.71,229,320.58,231.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.25,
    y1: 287.83,
    x2: 322.85,
    y2: 260.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.25,288.33h-.06a.49.49,0,0,1-.43-.56l3.6-27.45a.49.49,0,0,1,.56-.43.49.49,0,0,1,.43.56l-3.6,27.45A.51.51,0,0,1,319.25,288.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.45,210.42s-2.47.45-.67,3.82,6.52,4,6.52,4l2.93,8.1,14.4-1.12,2.25-8.55a6.14,6.14,0,0,0,5.18-4.28c1.35-4.05-.68-5.4-3.38-4.95S317.45,210.42,317.45,210.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.23,226.9a.51.51,0,0,1-.47-.34l-2.83-7.82c-1.11-.22-4.94-1.17-6.59-4.26-.75-1.39-.91-2.53-.5-3.39a2.23,2.23,0,0,1,1.52-1.16h0c.25,0,24.54-2.48,27.2-2.92a3.8,3.8,0,0,1,3.67,1c.59.69,1.12,2.06.26,4.64a6.68,6.68,0,0,1-5.25,4.57l-2.17,8.23a.5.5,0,0,1-.44.37l-14.4,1.12Zm-8.7-16a1.26,1.26,0,0,0-.79.62,3,3,0,0,0,.48,2.48c1.66,3.1,6.11,3.78,6.15,3.79a.49.49,0,0,1,.4.32l2.8,7.75,13.67-1.07,2.16-8.21a.48.48,0,0,1,.45-.37,5.59,5.59,0,0,0,4.73-3.93c.57-1.7.54-3-.07-3.68a2.89,2.89,0,0,0-2.75-.62C342.1,208.43,318.88,210.78,317.53,210.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.81,224.59S342,223,335.45,223.47a71.69,71.69,0,0,0-14.62,3.15l-.45,4s10.35-1.57,14.85-1.57,11.48.22,11.48.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.38,231.17A.52.52,0,0,1,320,231a.49.49,0,0,1-.15-.41l.45-4.06a.48.48,0,0,1,.34-.41c.08,0,8.24-2.73,14.75-3.18s10.42,1.1,10.58,1.16a.53.53,0,0,1,.3.37l.9,4.73a.53.53,0,0,1-.11.42.47.47,0,0,1-.4.17c-.07,0-7-.22-11.46-.22s-14.67,1.55-14.78,1.56Zm.91-4.17-.34,3.08a134.81,134.81,0,0,1,14.28-1.48c3.67,0,9,.15,10.87.2l-.73-3.83a25.84,25.84,0,0,0-9.88-1A69.94,69.94,0,0,0,321.29,227Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.65,186.79s-4-.9-9.22,5.18-3.6,8.1-2.25,11.92,9.45,12.83,13.5,14.63l4.05,1.8s-9.9,13.73-9.9,20.93,5.62,16.42,13.95,17.32,15.08-18.67,11.48-24.75-8.1-14.18-8.1-14.18,8.1-5.17,8.32-13,.68-15.07-5-20.47-11.25-6.08-13.73-3.6A13.87,13.87,0,0,0,324.65,186.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.33,259.1l-.6,0c-8.49-.92-14.4-10.13-14.4-17.82,0-6.58,7.83-18.14,9.64-20.72L326.48,219c-4.26-1.9-12.44-11.14-13.77-14.92l-.4-1.07c-1.23-3.28-2.12-5.65,2.74-11.35,4.42-5.19,8.09-5.47,9.3-5.39a16,16,0,0,1,3.1-4.09c2.6-2.6,8.39-2.2,14.43,3.59,5.56,5.35,5.35,12.44,5.13,19.94l0,.92c-.2,7.13-6.5,12-8.17,13.19,1,1.71,4.77,8.53,7.88,13.77,2.54,4.29.23,14.05-3.54,19.9C340.8,257.13,338,259.1,335.33,259.1Zm-11.25-71.85c-1.16,0-4.38.47-8.27,5-4.48,5.25-3.72,7.28-2.56,10.34l.4,1.1c1.25,3.54,9.24,12.56,13.23,14.33l4.05,1.8a.5.5,0,0,1,.2.75c-.09.14-9.8,13.68-9.8,20.64,0,7.25,5.77,16,13.5,16.83,2.52.27,5.17-1.56,7.48-5.15,3.93-6.11,5.64-15.27,3.52-18.85-3.57-6-8.07-14.11-8.11-14.19a.5.5,0,0,1,.17-.67c.07-.05,7.88-5.13,8.09-12.64l0-.92c.22-7.59.42-14.15-4.83-19.18-5.51-5.29-10.82-5.81-13-3.61a13.74,13.74,0,0,0-3,4.1.5.5,0,0,1-.57.31A3.16,3.16,0,0,0,324.08,187.25Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.47,198.82s2.51,5.79,2.32,7.14a13.28,13.28,0,0,0,0,4.83,10.55,10.55,0,0,1,.58,6.56c-.78,3.28-1.36,9.27-3.09,10.62s-5-.2-5-.2l-.2,6.76-15.63.58-1.55-10.81s-3.09-11.2,1.16-21.24S186.31,197.08,187.47,198.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.43,235.61a.51.51,0,0,1-.5-.43l-1.54-10.81c-.12-.4-3.08-11.42,1.19-21.5,2.1-5,6.83-6.41,10.43-6.75,5.24-.5,11,1.13,11.88,2.42l0,.08c.43,1,2.55,6,2.35,7.41a13.12,13.12,0,0,0,0,4.6l.13.36a10.64,10.64,0,0,1,.46,6.47c-.19.83-.37,1.83-.57,2.89-.61,3.39-1.25,6.89-2.7,8s-3.71.55-4.84.14l-.18,6a.49.49,0,0,1-.48.49l-15.63.58ZM178.06,197q-1,0-1.95.09c-3.33.31-7.7,1.64-9.61,6.15-4.13,9.76-1.17,20.8-1.14,20.91l1.5,10.42,14.72-.54.18-6.29a.47.47,0,0,1,.24-.41.49.49,0,0,1,.47,0c.84.39,3.28,1.2,4.5.25s1.8-4.5,2.33-7.4c.19-1.07.38-2.09.58-2.94a9.67,9.67,0,0,0-.43-5.9l-.14-.39a14.22,14.22,0,0,1,0-5.05c.13-.88-1.31-4.63-2.26-6.83C186.52,198.43,182.6,197,178.06,197Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.36,221a1,1,0,0,1-.33-.06,4,4,0,0,1-2-1.57.5.5,0,0,1,.86-.51h0a3,3,0,0,0,1.47,1.13,4.71,4.71,0,0,0,.69-2.64.5.5,0,0,1,.53-.47.51.51,0,0,1,.47.53c0,.64-.22,2.81-1.12,3.41A1,1,0,0,1,184.36,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,211.29a.5.5,0,0,1-.15-1l8.88-2.9a.5.5,0,0,1,.31,1l-8.88,2.89A.41.41,0,0,1,184.57,211.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,214.25a.5.5,0,0,1-.49-.38.51.51,0,0,1,.37-.61,3.75,3.75,0,0,0-.91-7.38.5.5,0,0,1,0-1,4.75,4.75,0,0,1,1.15,9.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.47,198.82s.58,3.09-.39,5a23.16,23.16,0,0,1-3.09,4.24s1,2.13.58,2.71-1-.78-1.73-.78-2.32,0-1.93,3.09a27.41,27.41,0,0,0,1.54,6,10,10,0,0,1-4.83,6.56c-4.24,2.51-10.23,2.12-12.16,1.16s-11.39-13.9-11.39-23,14.09-17,21.82-17,17,3.86,17,7.72S187.47,198.82,187.47,198.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.94,228.06a11.73,11.73,0,0,1-4.7-.8c-2.15-1.08-11.67-14.17-11.67-23.42,0-9.57,14.78-17.49,22.32-17.49,7.71,0,17.49,3.87,17.49,8.22,0,3.14-3.24,4.39-5.34,4.69a9.15,9.15,0,0,1-.51,4.8,22.67,22.67,0,0,1-2.95,4.12c.39.91.83,2.25.41,2.88a.73.73,0,0,1-.55.36,1.29,1.29,0,0,1-1-.49c-.19-.18-.45-.42-.61-.42a1.44,1.44,0,0,0-1.14.33,3,3,0,0,0-.3,2.2,27.87,27.87,0,0,0,1.51,5.86.46.46,0,0,1,0,.26,10.42,10.42,0,0,1-5.07,6.92A16,16,0,0,1,169.94,228.06Zm5.95-40.71c-7.21,0-21.32,7.46-21.32,16.49s9.5,21.71,11.12,22.52c1.86.93,7.71,1.21,11.68-1.14a9.6,9.6,0,0,0,4.56-6.08,28.58,28.58,0,0,1-1.52-6,3.68,3.68,0,0,1,.54-3,2.35,2.35,0,0,1,1.89-.67,2,2,0,0,1,1.29.68l0,0a7.81,7.81,0,0,0-.62-1.94.49.49,0,0,1,.09-.54,23.94,23.94,0,0,0,3-4.14c.87-1.75.34-4.67.34-4.7a.49.49,0,0,1,.45-.59s4.95-.4,4.95-3.75S183.59,187.35,175.89,187.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.76,232.79l-3.09,5.8s7.72-1,15.06-1.16a75.43,75.43,0,0,1,12.35.58l-1.93-5.22S169.52,229.9,162.76,232.79Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.67,239.08a.51.51,0,0,1-.41-.21.49.49,0,0,1,0-.52l3.09-5.79a.53.53,0,0,1,.24-.23c6.82-2.92,22-.15,22.68,0a.48.48,0,0,1,.38.32l1.93,5.21a.51.51,0,0,1-.08.49.49.49,0,0,1-.46.18,75.4,75.4,0,0,0-12.27-.57c-7.22.19-14.93,1.14-15,1.15Zm3.45-5.89L160.56,238c2.3-.26,8.38-.9,14.15-1a83.78,83.78,0,0,1,11.62.47l-1.55-4.16C182.68,232.87,169.25,230.7,163.12,233.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,246.5s-4.25,18.34-4.25,30.12-1.15,18.92,1.36,19.88S154.07,293,154.07,293l-4.82-42.86Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,297.13a3.05,3.05,0,0,1-1.07-.16c-2.16-.83-2.05-4.74-1.84-11.84.08-2.5.16-5.33.16-8.51,0-11.7,4.22-30.05,4.26-30.23A.51.51,0,0,1,145,246a.52.52,0,0,1,.49.11l4.05,3.67a.47.47,0,0,1,.16.31L154.57,293a.52.52,0,0,1-.28.51C153.43,293.89,146.55,297.13,143.19,297.13Zm2.3-49.68c-.82,3.71-4.05,19-4.05,29.17,0,3.2-.08,6-.16,8.54-.17,6-.3,10.3,1.2,10.87s7.39-1.57,11.05-3.3l-4.76-42.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.91,296.11s-6.37,4.83-9.26,23.94,2.89,50,6.56,57.92,4.44,10.81,4.25,13.51-4.83,8.11-1.55,22.4,7.15,39.19,7.15,39.19v2.31s-1.16.77-.78,1.55a28.29,28.29,0,0,1,1,4.05l8.49.19s2.13-3.28,2.13-6-.39-6.95-.39-6.95l-.19-7.53,2.12-80.5.77-16.22,15.25,49.42,18.92,63.32a67.13,67.13,0,0,0,7.15.2c1.93-.2,5-.78,5-.78a9.85,9.85,0,0,0,.19-3.86,27.94,27.94,0,0,0-2.51-5.79c-1.16-2.12-2.7-17.37-3.09-19.69s-1.54-25.29-3.28-30.69a56.3,56.3,0,0,0-4.63-10.24s-2.32-56.17-6.76-71-7.14-17.57-7.14-17.57S172.22,299.78,152.91,296.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.74,461.67h0l-8.49-.19a.49.49,0,0,1-.48-.41,27.47,27.47,0,0,0-.92-3.92,1.7,1.7,0,0,1,.72-2v-2.06c0-.18-3.89-25-7.13-39.08-2.55-11.08-.42-16.82.85-20.25a9.81,9.81,0,0,0,.68-2.29c.18-2.47-.41-5.08-4.2-13.27-3.88-8.37-9.46-39.4-6.61-58.2,2.9-19.1,9.19-24.06,9.46-24.26a.52.52,0,0,1,.4-.1c19,3.61,39,1.18,39.22,1.16a.48.48,0,0,1,.42.14c.11.11,2.84,3,7.27,17.78,4.3,14.41,6.64,68.05,6.77,71A57.51,57.51,0,0,1,211.3,396c1.26,3.92,2.22,16.89,2.79,24.64.23,3.07.41,5.49.51,6.13s.28,2,.5,3.86c.6,5,1.72,14.17,2.54,15.67a28.36,28.36,0,0,1,2.55,5.91,10.1,10.1,0,0,1-.19,4.11.51.51,0,0,1-.39.37c-.13,0-3.13.58-5.06.77a63.57,63.57,0,0,1-7.23-.19.47.47,0,0,1-.44-.35L188,393.56l-14.41-46.69-.64,13.36-2.12,80.49.19,7.51s.39,4.27.39,7-2.12,6.12-2.21,6.26A.5.5,0,0,1,168.74,461.67Zm-8.07-1.18,7.8.18c.46-.78,1.9-3.36,1.9-5.48,0-2.65-.38-6.86-.39-6.91l-.19-7.56,2.12-80.53.77-16.22a.5.5,0,0,1,.44-.47.49.49,0,0,1,.54.34l15.25,49.43,18.82,63a60.17,60.17,0,0,0,6.72.17c1.52-.15,3.81-.55,4.65-.71a8.56,8.56,0,0,0,.12-3.3,26.29,26.29,0,0,0-2.46-5.68c-.84-1.54-1.77-8.76-2.65-16-.22-1.81-.4-3.24-.49-3.82s-.29-3-.52-6.21c-.57-7.71-1.53-20.61-2.75-24.41a56,56,0,0,0-4.58-10.13.4.4,0,0,1-.07-.24c0-.56-2.37-56.28-6.74-70.92-3.75-12.54-6.26-16.37-6.88-17.18-2.47.28-21.15,2.2-39-1.15-1,.91-6.35,6.54-8.92,23.48-2.82,18.63,2.69,49.35,6.52,57.63,3.51,7.56,4.51,10.77,4.3,13.76a10.59,10.59,0,0,1-.74,2.57c-1.24,3.32-3.3,8.89-.82,19.67,3.25,14.14,7.11,39,7.15,39.23v2.39a.52.52,0,0,1-.22.42c-.22.14-.75.62-.61.9A23.07,23.07,0,0,1,160.67,460.49Zm-.61-5.11h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.67,238.59s-14.48,6.94-14.48,7.91,7.72,49.61,7.72,49.61,8.5,5.22,21.63,4.06,17.76-2.9,17.76-2.9S202,245.92,201,244.38s-13.9-6.37-13.9-6.37S168.74,235.11,159.67,238.59Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.69,300.84c-10.9,0-17.72-4.11-18-4.3a.5.5,0,0,1-.23-.35c-.79-5-7.73-48.71-7.73-49.69,0-.35,0-1.28,14.76-8.37h0c9.1-3.49,26.92-.73,27.67-.61l.1,0c2.18.81,13.14,5,14.15,6.57s-6.35,41.16-8.62,53.26a.48.48,0,0,1-.32.37c-.19.07-4.85,1.78-17.89,2.93C173.23,300.79,171.94,300.84,170.69,300.84Zm-17.32-5a38.3,38.3,0,0,0,21.12,3.87c11.2-1,16.22-2.41,17.37-2.78,3.78-20.13,9.17-50.47,8.67-52.31-.57-.9-8.27-4.11-13.57-6.09-1.06-.16-18.47-2.73-27.09.55-5.44,2.62-13.28,6.62-14.17,7.57C146,248.86,150.77,279.41,153.37,295.8Zm-7.72-49.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.58 235.69 228.2 238.97 218.36 273.14 196.93 267.54 206.58 235.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,273.64a.3.3,0,0,1-.13,0L196.8,268a.5.5,0,0,1-.35-.63l9.65-31.86a.51.51,0,0,1,.56-.34l21.62,3.28a.47.47,0,0,1,.34.22.49.49,0,0,1,.06.41l-9.84,34.17A.49.49,0,0,1,218.36,273.64Zm-20.8-6.45L218,272.53l9.56-33.15-20.64-3.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.51,281.64s5.79-10.82,6.37-11.2-1-5.6-.77-6.95a18.41,18.41,0,0,1,1.35-4.44c.77-1.93-.19-3.67,1.16-3.28s1.74,1.15,1.54,3.09-.19,3.28-.19,3.28l5-4.25,1.55-4.83a13.36,13.36,0,0,1,1.35,4.64,9.38,9.38,0,0,1-.58,3.47c-.2.58,0,4.64-2.13,7.92s-3.08,3.86-3.47,4.82-1.16,8.5-3.48,14.87-4.63,11.77-7.72,12.74-5.4-6.95-4-11.58A29.64,29.64,0,0,1,208.51,281.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,302.1a2.59,2.59,0,0,1-1.83-.85c-2.17-2.12-3.25-7.8-2.18-11.45a29.85,29.85,0,0,1,4.11-8.43c2.08-3.89,5.58-10.32,6.41-11.25a15.84,15.84,0,0,0-.43-3.12,15.12,15.12,0,0,1-.45-3.58,18.44,18.44,0,0,1,1.38-4.56,5.56,5.56,0,0,0,.32-2c0-.62,0-1.16.42-1.46a1.15,1.15,0,0,1,1-.09c1.83.52,2.09,1.77,1.9,3.62-.08.84-.13,1.57-.15,2.12l4.05-3.43,1.5-4.69a.48.48,0,0,1,.44-.34.46.46,0,0,1,.48.27,13.55,13.55,0,0,1,1.41,4.86,9.69,9.69,0,0,1-.56,3.49l-.05.14c0,.08-.05.42-.07.72a15.77,15.77,0,0,1-2.11,7.31,34.17,34.17,0,0,1-2.56,3.5,5.08,5.08,0,0,0-.87,1.24c-.09.24-.26,1.2-.45,2.3a73,73,0,0,1-3,12.55c-2.18,6-4.61,12-8,13.05A2.25,2.25,0,0,1,208,302.1Zm8.36-45.88a5.72,5.72,0,0,0,0,.64,6.62,6.62,0,0,1-.39,2.37,17.89,17.89,0,0,0-1.32,4.33,16,16,0,0,0,.44,3.25c.53,2.76.66,3.68.11,4s-4.06,7-6.21,11l0,.06a29.51,29.51,0,0,0-4,8.15c-.95,3.24,0,8.62,1.92,10.46a1.44,1.44,0,0,0,1.5.5c3-.93,5.4-6.91,7.4-12.43a72.63,72.63,0,0,0,3-12.37,19.93,19.93,0,0,1,.5-2.51,6.15,6.15,0,0,1,1-1.51,31.37,31.37,0,0,0,2.49-3.4,14.87,14.87,0,0,0,2-6.85,4.71,4.71,0,0,1,.12-1l0-.14a8.75,8.75,0,0,0,.51-3.17,9.87,9.87,0,0,0-.78-3.22L223.47,258a.46.46,0,0,1-.16.23l-5,4.25a.51.51,0,0,1-.53.07.49.49,0,0,1-.29-.45c0-.06,0-1.4.2-3.33s-.2-2.28-1.19-2.56Zm-7.84,25.42h0Zm6.1-11.62-.07.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.47,270.44s9.46,25.48,12.16,29.15,9.65,2.51,11.2-.77.39-9.08-.19-12-4.25-23.55-5.22-30.12A37.94,37.94,0,0,0,201,244.38s-4.44-2.9-7.33-.39",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.73,302.36a6.67,6.67,0,0,1-5.5-2.47c-2.71-3.69-11.84-28.23-12.23-29.28a.5.5,0,0,1,.94-.35c.09.26,9.46,25.46,12.09,29a6,6,0,0,0,5.51,2c2.23-.22,4.17-1.31,4.84-2.72,1.47-3.13.32-8.89-.23-11.65-.62-3.09-4.26-23.58-5.22-30.15a37.51,37.51,0,0,0-4.32-12.06c-.63-.38-4.28-2.41-6.64-.37a.49.49,0,0,1-.7-.05.51.51,0,0,1,0-.71c3.15-2.72,7.74.22,7.94.35a.46.46,0,0,1,.15.16,38,38,0,0,1,4.51,12.54c.93,6.35,4.6,27.08,5.21,30.09s1.77,8.85.15,12.28c-.82,1.74-3,3-5.64,3.29C205.33,302.35,205,302.36,204.73,302.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.18,344.49a.43.43,0,0,1-.19,0L162.43,340a.5.5,0,0,1-.27-.66.51.51,0,0,1,.66-.26l10.56,4.49a.5.5,0,0,1,.26.66A.49.49,0,0,1,173.18,344.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.25 460.98 159.91 471.76 169.96 471.76 168.74 461.17 160.25 460.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,472.26H159.91a.52.52,0,0,1-.36-.16.51.51,0,0,1-.14-.36l.34-10.77a.51.51,0,0,1,.5-.49h0l8.5.19a.5.5,0,0,1,.48.45l1.21,10.58a.51.51,0,0,1-.12.39A.5.5,0,0,1,170,472.26Zm-9.53-1h9l-1.1-9.6-7.57-.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.91 471.76 169.96 471.76 169.65 469.11 159.99 469.11 159.91 471.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,472.26H159.91a.52.52,0,0,1-.36-.16.51.51,0,0,1-.14-.36l.08-2.64a.51.51,0,0,1,.5-.49h9.66a.5.5,0,0,1,.5.45l.3,2.64a.51.51,0,0,1-.12.39A.5.5,0,0,1,170,472.26Zm-9.53-1h9l-.19-1.65h-8.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.35,456.73s-2.5,10.44-1.62,11,7.75,1.76,10.05,2.47a49.13,49.13,0,0,0,9.86,1.94c2.3,0,6,0,6.17-1.24s.36-2.11-.53-2.64a58.53,58.53,0,0,1-7.75-6.34,19.49,19.49,0,0,1-4-5.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.64,472.61c-2.39,0-7.79-1.28-10-2-1-.31-2.89-.72-4.73-1.12a32.53,32.53,0,0,1-5.43-1.4c-.32-.2-1.19-.72,1.4-11.51a.49.49,0,0,1,.46-.38l12.16-.58a.46.46,0,0,1,.49.3,19,19,0,0,0,3.9,5.57,57.16,57.16,0,0,0,7.66,6.27c1.13.68,1,1.79.79,3l0,.18C232.09,472.48,229.16,472.61,225.64,472.61Zm-19.57-5.29a50.93,50.93,0,0,0,5,1.23c1.86.41,3.79.83,4.81,1.14a48,48,0,0,0,9.72,1.92c3.69,0,5.6-.27,5.68-.81l0-.17c.18-1.24.2-1.66-.31-2a57.41,57.41,0,0,1-7.85-6.42,20.64,20.64,0,0,1-4-5.57l-11.45.55C206.71,461.62,205.83,466.43,206.07,467.32Zm0,.06h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,467c-4.83-2.05-8.13-2.47-10.18-2.42-.25,1.65-.34,2.94,0,3.12.88.53,7.75,1.76,10.05,2.47a49.13,49.13,0,0,0,9.86,1.94c2.3,0,6,0,6.17-1.24a9,9,0,0,0,.14-1.35C229.48,469.92,223.5,470.19,216,467Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.64,472.61c-2.39,0-7.79-1.28-10-2-1-.31-2.89-.72-4.73-1.12a31.92,31.92,0,0,1-5.43-1.4c-.44-.26-.6-.92-.2-3.62a.51.51,0,0,1,.48-.43c2-.05,5.38.34,10.4,2.46h0c8,3.37,14,2.76,15.72,2.49a.55.55,0,0,1,.41.11.52.52,0,0,1,.17.38,9.91,9.91,0,0,1-.13,1.33C232.09,472.48,229.16,472.61,225.64,472.61Zm-19.57-5.29a51.68,51.68,0,0,0,5,1.23c1.86.41,3.79.83,4.81,1.14a48,48,0,0,0,9.72,1.92c3.69,0,5.6-.27,5.68-.81,0-.26.07-.49.09-.7a31.46,31.46,0,0,1-15.65-2.64h0a25.62,25.62,0,0,0-9.56-2.38A8.28,8.28,0,0,0,206.07,467.32Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg9);
export default __webpack_public_path__ + "static/media/img9.356e0ead5e46b8353e2e3bb105341240.svg";
export { ForwardRef as ReactComponent };